function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M65.7812 340.438H58.6875V360H54.7656V340.438H47.7344V337.25H65.7812V340.438ZM72.1562 344.938C73.3958 343.5 74.9635 342.781 76.8594 342.781C80.4635 342.781 82.2917 344.839 82.3438 348.953V360H78.5469V349.094C78.5469 347.927 78.2917 347.104 77.7812 346.625C77.2812 346.135 76.5417 345.891 75.5625 345.891C74.0417 345.891 72.9062 346.568 72.1562 347.922V360H68.3594V336H72.1562V344.938ZM90.2344 360H86.4375V343.094H90.2344V360ZM86.2031 338.703C86.2031 338.12 86.3854 337.635 86.75 337.25C87.125 336.865 87.6562 336.672 88.3438 336.672C89.0312 336.672 89.5625 336.865 89.9375 337.25C90.3125 337.635 90.5 338.12 90.5 338.703C90.5 339.276 90.3125 339.755 89.9375 340.141C89.5625 340.516 89.0312 340.703 88.3438 340.703C87.6562 340.703 87.125 340.516 86.75 340.141C86.3854 339.755 86.2031 339.276 86.2031 338.703ZM103.859 355.406C103.859 354.729 103.578 354.214 103.016 353.859C102.464 353.505 101.542 353.193 100.25 352.922C98.9583 352.651 97.8802 352.307 97.0156 351.891C95.1198 350.974 94.1719 349.646 94.1719 347.906C94.1719 346.448 94.7865 345.229 96.0156 344.25C97.2448 343.271 98.8073 342.781 100.703 342.781C102.724 342.781 104.354 343.281 105.594 344.281C106.844 345.281 107.469 346.578 107.469 348.172H103.672C103.672 347.443 103.401 346.839 102.859 346.359C102.318 345.87 101.599 345.625 100.703 345.625C99.8698 345.625 99.1875 345.818 98.6562 346.203C98.1354 346.589 97.875 347.104 97.875 347.75C97.875 348.333 98.1198 348.786 98.6094 349.109C99.099 349.432 100.089 349.76 101.578 350.094C103.068 350.417 104.234 350.807 105.078 351.266C105.932 351.714 106.562 352.255 106.969 352.891C107.385 353.526 107.594 354.297 107.594 355.203C107.594 356.724 106.964 357.958 105.703 358.906C104.443 359.844 102.792 360.312 100.75 360.312C99.3646 360.312 98.1302 360.062 97.0469 359.562C95.9635 359.062 95.1198 358.375 94.5156 357.5C93.9115 356.625 93.6094 355.682 93.6094 354.672H97.2969C97.349 355.568 97.6875 356.26 98.3125 356.75C98.9375 357.229 99.7656 357.469 100.797 357.469C101.797 357.469 102.557 357.281 103.078 356.906C103.599 356.521 103.859 356.021 103.859 355.406ZM133.688 351.719C133.688 354.333 133.094 356.422 131.906 357.984C130.719 359.536 129.125 360.312 127.125 360.312C125.271 360.312 123.786 359.703 122.672 358.484V366.5H118.875V343.094H122.375L122.531 344.812C123.646 343.458 125.161 342.781 127.078 342.781C129.141 342.781 130.755 343.552 131.922 345.094C133.099 346.625 133.688 348.755 133.688 351.484V351.719ZM129.906 351.391C129.906 349.703 129.568 348.365 128.891 347.375C128.224 346.385 127.266 345.891 126.016 345.891C124.464 345.891 123.349 346.531 122.672 347.812V355.312C123.359 356.625 124.484 357.281 126.047 357.281C127.255 357.281 128.198 356.797 128.875 355.828C129.562 354.849 129.906 353.37 129.906 351.391ZM147.016 360C146.849 359.677 146.703 359.151 146.578 358.422C145.37 359.682 143.891 360.312 142.141 360.312C140.443 360.312 139.057 359.828 137.984 358.859C136.911 357.891 136.375 356.693 136.375 355.266C136.375 353.464 137.042 352.083 138.375 351.125C139.719 350.156 141.635 349.672 144.125 349.672H146.453V348.562C146.453 347.688 146.208 346.99 145.719 346.469C145.229 345.938 144.484 345.672 143.484 345.672C142.62 345.672 141.911 345.891 141.359 346.328C140.807 346.755 140.531 347.302 140.531 347.969H136.734C136.734 347.042 137.042 346.177 137.656 345.375C138.271 344.562 139.104 343.927 140.156 343.469C141.219 343.01 142.401 342.781 143.703 342.781C145.682 342.781 147.26 343.281 148.438 344.281C149.615 345.271 150.219 346.667 150.25 348.469V356.094C150.25 357.615 150.464 358.828 150.891 359.734V360H147.016ZM142.844 357.266C143.594 357.266 144.297 357.083 144.953 356.719C145.62 356.354 146.12 355.865 146.453 355.25V352.062H144.406C143 352.062 141.943 352.307 141.234 352.797C140.526 353.286 140.172 353.979 140.172 354.875C140.172 355.604 140.411 356.188 140.891 356.625C141.38 357.052 142.031 357.266 142.844 357.266ZM153.562 351.422C153.562 348.797 154.177 346.703 155.406 345.141C156.646 343.568 158.286 342.781 160.328 342.781C162.255 342.781 163.771 343.453 164.875 344.797L165.047 343.094H168.469V359.484C168.469 361.703 167.776 363.453 166.391 364.734C165.016 366.016 163.156 366.656 160.812 366.656C159.573 366.656 158.359 366.396 157.172 365.875C155.995 365.365 155.099 364.693 154.484 363.859L156.281 361.578C157.448 362.964 158.885 363.656 160.594 363.656C161.854 363.656 162.849 363.312 163.578 362.625C164.307 361.948 164.672 360.948 164.672 359.625V358.484C163.578 359.703 162.12 360.312 160.297 360.312C158.318 360.312 156.698 359.526 155.438 357.953C154.188 356.38 153.562 354.203 153.562 351.422ZM157.344 351.75C157.344 353.448 157.688 354.786 158.375 355.766C159.073 356.734 160.036 357.219 161.266 357.219C162.797 357.219 163.932 356.562 164.672 355.25V347.812C163.953 346.531 162.828 345.891 161.297 345.891C160.047 345.891 159.073 346.385 158.375 347.375C157.688 348.365 157.344 349.823 157.344 351.75ZM179.828 360.312C177.422 360.312 175.469 359.557 173.969 358.047C172.479 356.526 171.734 354.505 171.734 351.984V351.516C171.734 349.828 172.057 348.323 172.703 347C173.359 345.667 174.276 344.63 175.453 343.891C176.63 343.151 177.943 342.781 179.391 342.781C181.693 342.781 183.469 343.516 184.719 344.984C185.979 346.453 186.609 348.531 186.609 351.219V352.75H175.562C175.677 354.146 176.141 355.25 176.953 356.062C177.776 356.875 178.807 357.281 180.047 357.281C181.786 357.281 183.203 356.578 184.297 355.172L186.344 357.125C185.667 358.135 184.76 358.922 183.625 359.484C182.5 360.036 181.234 360.312 179.828 360.312ZM179.375 345.828C178.333 345.828 177.49 346.193 176.844 346.922C176.208 347.651 175.802 348.667 175.625 349.969H182.859V349.688C182.776 348.417 182.438 347.458 181.844 346.812C181.25 346.156 180.427 345.828 179.375 345.828ZM201.578 360H197.781V343.094H201.578V360ZM197.547 338.703C197.547 338.12 197.729 337.635 198.094 337.25C198.469 336.865 199 336.672 199.688 336.672C200.375 336.672 200.906 336.865 201.281 337.25C201.656 337.635 201.844 338.12 201.844 338.703C201.844 339.276 201.656 339.755 201.281 340.141C200.906 340.516 200.375 340.703 199.688 340.703C199 340.703 198.469 340.516 198.094 340.141C197.729 339.755 197.547 339.276 197.547 338.703ZM215.203 355.406C215.203 354.729 214.922 354.214 214.359 353.859C213.807 353.505 212.885 353.193 211.594 352.922C210.302 352.651 209.224 352.307 208.359 351.891C206.464 350.974 205.516 349.646 205.516 347.906C205.516 346.448 206.13 345.229 207.359 344.25C208.589 343.271 210.151 342.781 212.047 342.781C214.068 342.781 215.698 343.281 216.938 344.281C218.188 345.281 218.812 346.578 218.812 348.172H215.016C215.016 347.443 214.745 346.839 214.203 346.359C213.661 345.87 212.943 345.625 212.047 345.625C211.214 345.625 210.531 345.818 210 346.203C209.479 346.589 209.219 347.104 209.219 347.75C209.219 348.333 209.464 348.786 209.953 349.109C210.443 349.432 211.432 349.76 212.922 350.094C214.411 350.417 215.578 350.807 216.422 351.266C217.276 351.714 217.906 352.255 218.312 352.891C218.729 353.526 218.938 354.297 218.938 355.203C218.938 356.724 218.307 357.958 217.047 358.906C215.786 359.844 214.135 360.312 212.094 360.312C210.708 360.312 209.474 360.062 208.391 359.562C207.307 359.062 206.464 358.375 205.859 357.5C205.255 356.625 204.953 355.682 204.953 354.672H208.641C208.693 355.568 209.031 356.26 209.656 356.75C210.281 357.229 211.109 357.469 212.141 357.469C213.141 357.469 213.901 357.281 214.422 356.906C214.943 356.521 215.203 356.021 215.203 355.406ZM240.469 358.344C239.354 359.656 237.771 360.312 235.719 360.312C233.885 360.312 232.495 359.776 231.547 358.703C230.609 357.63 230.141 356.078 230.141 354.047V343.094H233.938V354C233.938 356.146 234.828 357.219 236.609 357.219C238.453 357.219 239.698 356.557 240.344 355.234V343.094H244.141V360H240.562L240.469 358.344ZM251.531 343.094L251.641 345.047C252.891 343.536 254.531 342.781 256.562 342.781C260.083 342.781 261.875 344.797 261.938 348.828V360H258.141V349.047C258.141 347.974 257.906 347.182 257.438 346.672C256.979 346.151 256.224 345.891 255.172 345.891C253.641 345.891 252.5 346.583 251.75 347.969V360H247.953V343.094H251.531ZM265.109 351.422C265.109 348.818 265.714 346.729 266.922 345.156C268.13 343.573 269.75 342.781 271.781 342.781C273.573 342.781 275.021 343.406 276.125 344.656V336H279.922V360H276.484L276.297 358.25C275.161 359.625 273.646 360.312 271.75 360.312C269.771 360.312 268.167 359.516 266.938 357.922C265.719 356.328 265.109 354.161 265.109 351.422ZM268.906 351.75C268.906 353.469 269.234 354.812 269.891 355.781C270.557 356.74 271.5 357.219 272.719 357.219C274.271 357.219 275.406 356.526 276.125 355.141V347.922C275.427 346.568 274.302 345.891 272.75 345.891C271.521 345.891 270.573 346.38 269.906 347.359C269.24 348.328 268.906 349.792 268.906 351.75ZM291.328 360.312C288.922 360.312 286.969 359.557 285.469 358.047C283.979 356.526 283.234 354.505 283.234 351.984V351.516C283.234 349.828 283.557 348.323 284.203 347C284.859 345.667 285.776 344.63 286.953 343.891C288.13 343.151 289.443 342.781 290.891 342.781C293.193 342.781 294.969 343.516 296.219 344.984C297.479 346.453 298.109 348.531 298.109 351.219V352.75H287.062C287.177 354.146 287.641 355.25 288.453 356.062C289.276 356.875 290.307 357.281 291.547 357.281C293.286 357.281 294.703 356.578 295.797 355.172L297.844 357.125C297.167 358.135 296.26 358.922 295.125 359.484C294 360.036 292.734 360.312 291.328 360.312ZM290.875 345.828C289.833 345.828 288.99 346.193 288.344 346.922C287.708 347.651 287.302 348.667 287.125 349.969H294.359V349.688C294.276 348.417 293.938 347.458 293.344 346.812C292.75 346.156 291.927 345.828 290.875 345.828ZM309.922 346.562C309.422 346.479 308.906 346.438 308.375 346.438C306.635 346.438 305.464 347.104 304.859 348.438V360H301.062V343.094H304.688L304.781 344.984C305.698 343.516 306.969 342.781 308.594 342.781C309.135 342.781 309.583 342.854 309.938 343L309.922 346.562ZM327.234 357.281C328.182 357.281 328.969 357.005 329.594 356.453C330.219 355.901 330.552 355.219 330.594 354.406H334.172C334.13 355.458 333.802 356.443 333.188 357.359C332.573 358.266 331.74 358.984 330.688 359.516C329.635 360.047 328.5 360.312 327.281 360.312C324.917 360.312 323.042 359.547 321.656 358.016C320.271 356.484 319.578 354.37 319.578 351.672V351.281C319.578 348.708 320.266 346.651 321.641 345.109C323.016 343.557 324.891 342.781 327.266 342.781C329.276 342.781 330.911 343.37 332.172 344.547C333.443 345.714 334.109 347.25 334.172 349.156H330.594C330.552 348.188 330.219 347.391 329.594 346.766C328.979 346.141 328.193 345.828 327.234 345.828C326.005 345.828 325.057 346.276 324.391 347.172C323.724 348.057 323.385 349.406 323.375 351.219V351.828C323.375 353.661 323.703 355.031 324.359 355.938C325.026 356.833 325.984 357.281 327.234 357.281ZM336.328 351.391C336.328 349.734 336.656 348.245 337.312 346.922C337.969 345.589 338.891 344.568 340.078 343.859C341.266 343.141 342.63 342.781 344.172 342.781C346.453 342.781 348.302 343.516 349.719 344.984C351.146 346.453 351.917 348.401 352.031 350.828L352.047 351.719C352.047 353.385 351.724 354.875 351.078 356.188C350.443 357.5 349.526 358.516 348.328 359.234C347.141 359.953 345.766 360.312 344.203 360.312C341.818 360.312 339.906 359.521 338.469 357.938C337.042 356.344 336.328 354.224 336.328 351.578V351.391ZM340.125 351.719C340.125 353.458 340.484 354.823 341.203 355.812C341.922 356.792 342.922 357.281 344.203 357.281C345.484 357.281 346.479 356.781 347.188 355.781C347.906 354.781 348.266 353.318 348.266 351.391C348.266 349.682 347.896 348.328 347.156 347.328C346.427 346.328 345.432 345.828 344.172 345.828C342.932 345.828 341.948 346.323 341.219 347.312C340.49 348.292 340.125 349.76 340.125 351.719ZM358.781 343.094L358.891 345.047C360.141 343.536 361.781 342.781 363.812 342.781C367.333 342.781 369.125 344.797 369.188 348.828V360H365.391V349.047C365.391 347.974 365.156 347.182 364.688 346.672C364.229 346.151 363.474 345.891 362.422 345.891C360.891 345.891 359.75 346.583 359 347.969V360H355.203V343.094H358.781ZM382.547 355.406C382.547 354.729 382.266 354.214 381.703 353.859C381.151 353.505 380.229 353.193 378.938 352.922C377.646 352.651 376.568 352.307 375.703 351.891C373.807 350.974 372.859 349.646 372.859 347.906C372.859 346.448 373.474 345.229 374.703 344.25C375.932 343.271 377.495 342.781 379.391 342.781C381.411 342.781 383.042 343.281 384.281 344.281C385.531 345.281 386.156 346.578 386.156 348.172H382.359C382.359 347.443 382.089 346.839 381.547 346.359C381.005 345.87 380.286 345.625 379.391 345.625C378.557 345.625 377.875 345.818 377.344 346.203C376.823 346.589 376.562 347.104 376.562 347.75C376.562 348.333 376.807 348.786 377.297 349.109C377.786 349.432 378.776 349.76 380.266 350.094C381.755 350.417 382.922 350.807 383.766 351.266C384.62 351.714 385.25 352.255 385.656 352.891C386.073 353.526 386.281 354.297 386.281 355.203C386.281 356.724 385.651 357.958 384.391 358.906C383.13 359.844 381.479 360.312 379.438 360.312C378.052 360.312 376.818 360.062 375.734 359.562C374.651 359.062 373.807 358.375 373.203 357.5C372.599 356.625 372.297 355.682 372.297 354.672H375.984C376.036 355.568 376.375 356.26 377 356.75C377.625 357.229 378.453 357.469 379.484 357.469C380.484 357.469 381.245 357.281 381.766 356.906C382.286 356.521 382.547 356.021 382.547 355.406ZM394.359 338.984V343.094H397.344V345.906H394.359V355.344C394.359 355.99 394.484 356.458 394.734 356.75C394.995 357.031 395.453 357.172 396.109 357.172C396.547 357.172 396.99 357.12 397.438 357.016V359.953C396.573 360.193 395.74 360.312 394.938 360.312C392.021 360.312 390.562 358.703 390.562 355.484V345.906H387.781V343.094H390.562V338.984H394.359ZM409.109 346.562C408.609 346.479 408.094 346.438 407.562 346.438C405.823 346.438 404.651 347.104 404.047 348.438V360H400.25V343.094H403.875L403.969 344.984C404.885 343.516 406.156 342.781 407.781 342.781C408.323 342.781 408.771 342.854 409.125 343L409.109 346.562ZM421.75 358.344C420.635 359.656 419.052 360.312 417 360.312C415.167 360.312 413.776 359.776 412.828 358.703C411.891 357.63 411.422 356.078 411.422 354.047V343.094H415.219V354C415.219 356.146 416.109 357.219 417.891 357.219C419.734 357.219 420.979 356.557 421.625 355.234V343.094H425.422V360H421.844L421.75 358.344ZM436.234 357.281C437.182 357.281 437.969 357.005 438.594 356.453C439.219 355.901 439.552 355.219 439.594 354.406H443.172C443.13 355.458 442.802 356.443 442.188 357.359C441.573 358.266 440.74 358.984 439.688 359.516C438.635 360.047 437.5 360.312 436.281 360.312C433.917 360.312 432.042 359.547 430.656 358.016C429.271 356.484 428.578 354.37 428.578 351.672V351.281C428.578 348.708 429.266 346.651 430.641 345.109C432.016 343.557 433.891 342.781 436.266 342.781C438.276 342.781 439.911 343.37 441.172 344.547C442.443 345.714 443.109 347.25 443.172 349.156H439.594C439.552 348.188 439.219 347.391 438.594 346.766C437.979 346.141 437.193 345.828 436.234 345.828C435.005 345.828 434.057 346.276 433.391 347.172C432.724 348.057 432.385 349.406 432.375 351.219V351.828C432.375 353.661 432.703 355.031 433.359 355.938C434.026 356.833 434.984 357.281 436.234 357.281ZM450.797 338.984V343.094H453.781V345.906H450.797V355.344C450.797 355.99 450.922 356.458 451.172 356.75C451.432 357.031 451.891 357.172 452.547 357.172C452.984 357.172 453.427 357.12 453.875 357.016V359.953C453.01 360.193 452.177 360.312 451.375 360.312C448.458 360.312 447 358.703 447 355.484V345.906H444.219V343.094H447V338.984H450.797ZM460.734 360H456.938V343.094H460.734V360ZM456.703 338.703C456.703 338.12 456.885 337.635 457.25 337.25C457.625 336.865 458.156 336.672 458.844 336.672C459.531 336.672 460.062 336.865 460.438 337.25C460.812 337.635 461 338.12 461 338.703C461 339.276 460.812 339.755 460.438 340.141C460.062 340.516 459.531 340.703 458.844 340.703C458.156 340.703 457.625 340.516 457.25 340.141C456.885 339.755 456.703 339.276 456.703 338.703ZM464.172 351.391C464.172 349.734 464.5 348.245 465.156 346.922C465.812 345.589 466.734 344.568 467.922 343.859C469.109 343.141 470.474 342.781 472.016 342.781C474.297 342.781 476.146 343.516 477.562 344.984C478.99 346.453 479.76 348.401 479.875 350.828L479.891 351.719C479.891 353.385 479.568 354.875 478.922 356.188C478.286 357.5 477.37 358.516 476.172 359.234C474.984 359.953 473.609 360.312 472.047 360.312C469.661 360.312 467.75 359.521 466.312 357.938C464.885 356.344 464.172 354.224 464.172 351.578V351.391ZM467.969 351.719C467.969 353.458 468.328 354.823 469.047 355.812C469.766 356.792 470.766 357.281 472.047 357.281C473.328 357.281 474.323 356.781 475.031 355.781C475.75 354.781 476.109 353.318 476.109 351.391C476.109 349.682 475.74 348.328 475 347.328C474.271 346.328 473.276 345.828 472.016 345.828C470.776 345.828 469.792 346.323 469.062 347.312C468.333 348.292 467.969 349.76 467.969 351.719ZM486.625 343.094L486.734 345.047C487.984 343.536 489.625 342.781 491.656 342.781C495.177 342.781 496.969 344.797 497.031 348.828V360H493.234V349.047C493.234 347.974 493 347.182 492.531 346.672C492.073 346.151 491.318 345.891 490.266 345.891C488.734 345.891 487.594 346.583 486.844 347.969V360H483.047V343.094H486.625Z",
  fill: "black",
  fillOpacity: 0.87
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M135.539 390.859H131.883V401H130.391V390.859H126.742V389.625H135.539V390.859ZM135.836 396.695C135.836 395.867 135.997 395.122 136.32 394.461C136.648 393.799 137.102 393.289 137.68 392.93C138.263 392.57 138.927 392.391 139.672 392.391C140.823 392.391 141.753 392.789 142.461 393.586C143.174 394.383 143.531 395.443 143.531 396.766V396.867C143.531 397.69 143.372 398.43 143.055 399.086C142.742 399.737 142.292 400.245 141.703 400.609C141.12 400.974 140.448 401.156 139.688 401.156C138.542 401.156 137.612 400.758 136.898 399.961C136.19 399.164 135.836 398.109 135.836 396.797V396.695ZM137.289 396.867C137.289 397.805 137.505 398.557 137.938 399.125C138.375 399.693 138.958 399.977 139.688 399.977C140.422 399.977 141.005 399.69 141.438 399.117C141.87 398.539 142.086 397.732 142.086 396.695C142.086 395.768 141.865 395.018 141.422 394.445C140.984 393.867 140.401 393.578 139.672 393.578C138.958 393.578 138.383 393.862 137.945 394.43C137.508 394.997 137.289 395.81 137.289 396.867ZM150.672 392.547L150.711 393.484C151.331 392.755 152.167 392.391 153.219 392.391C154.401 392.391 155.206 392.844 155.633 393.75C155.914 393.344 156.279 393.016 156.727 392.766C157.18 392.516 157.714 392.391 158.328 392.391C160.182 392.391 161.125 393.372 161.156 395.336V401H159.711V395.422C159.711 394.818 159.573 394.367 159.297 394.07C159.021 393.768 158.557 393.617 157.906 393.617C157.37 393.617 156.924 393.779 156.57 394.102C156.216 394.419 156.01 394.849 155.953 395.391V401H154.5V395.461C154.5 394.232 153.898 393.617 152.695 393.617C151.747 393.617 151.099 394.021 150.75 394.828V401H149.305V392.547H150.672ZM168.562 401C168.479 400.833 168.411 400.536 168.359 400.109C167.688 400.807 166.885 401.156 165.953 401.156C165.12 401.156 164.435 400.922 163.898 400.453C163.367 399.979 163.102 399.38 163.102 398.656C163.102 397.776 163.435 397.094 164.102 396.609C164.773 396.12 165.716 395.875 166.93 395.875H168.336V395.211C168.336 394.706 168.185 394.305 167.883 394.008C167.581 393.706 167.135 393.555 166.547 393.555C166.031 393.555 165.599 393.685 165.25 393.945C164.901 394.206 164.727 394.521 164.727 394.891H163.273C163.273 394.469 163.422 394.062 163.719 393.672C164.021 393.276 164.427 392.964 164.938 392.734C165.453 392.505 166.018 392.391 166.633 392.391C167.607 392.391 168.37 392.635 168.922 393.125C169.474 393.609 169.76 394.279 169.781 395.133V399.023C169.781 399.799 169.88 400.417 170.078 400.875V401H168.562ZM166.164 399.898C166.617 399.898 167.047 399.781 167.453 399.547C167.859 399.312 168.154 399.008 168.336 398.633V396.898H167.203C165.432 396.898 164.547 397.417 164.547 398.453C164.547 398.906 164.698 399.26 165 399.516C165.302 399.771 165.69 399.898 166.164 399.898ZM174.406 397.086L173.5 398.031V401H172.055V389H173.5V396.258L174.273 395.328L176.906 392.547H178.664L175.375 396.078L179.047 401H177.352L174.406 397.086ZM183.508 401.156C182.362 401.156 181.43 400.781 180.711 400.031C179.992 399.276 179.633 398.268 179.633 397.008V396.742C179.633 395.904 179.792 395.156 180.109 394.5C180.432 393.839 180.88 393.323 181.453 392.953C182.031 392.578 182.656 392.391 183.328 392.391C184.427 392.391 185.281 392.753 185.891 393.477C186.5 394.201 186.805 395.237 186.805 396.586V397.188H181.078C181.099 398.021 181.341 398.695 181.805 399.211C182.273 399.721 182.867 399.977 183.586 399.977C184.096 399.977 184.529 399.872 184.883 399.664C185.237 399.456 185.547 399.18 185.812 398.836L186.695 399.523C185.987 400.612 184.924 401.156 183.508 401.156ZM183.328 393.578C182.745 393.578 182.255 393.792 181.859 394.219C181.464 394.641 181.219 395.234 181.125 396H185.359V395.891C185.318 395.156 185.12 394.589 184.766 394.188C184.411 393.781 183.932 393.578 183.328 393.578ZM194.414 390.5V392.547H195.992V393.664H194.414V398.906C194.414 399.245 194.484 399.5 194.625 399.672C194.766 399.839 195.005 399.922 195.344 399.922C195.51 399.922 195.74 399.891 196.031 399.828V401C195.651 401.104 195.281 401.156 194.922 401.156C194.276 401.156 193.789 400.961 193.461 400.57C193.133 400.18 192.969 399.625 192.969 398.906V393.664H191.43V392.547H192.969V390.5H194.414ZM199.133 393.57C199.773 392.784 200.607 392.391 201.633 392.391C203.419 392.391 204.32 393.398 204.336 395.414V401H202.891V395.406C202.885 394.797 202.745 394.346 202.469 394.055C202.198 393.763 201.773 393.617 201.195 393.617C200.727 393.617 200.315 393.742 199.961 393.992C199.607 394.242 199.331 394.57 199.133 394.977V401H197.688V389H199.133V393.57ZM208.07 401H206.625V392.547H208.07V401ZM206.508 390.305C206.508 390.07 206.578 389.872 206.719 389.711C206.865 389.549 207.078 389.469 207.359 389.469C207.641 389.469 207.854 389.549 208 389.711C208.146 389.872 208.219 390.07 208.219 390.305C208.219 390.539 208.146 390.734 208 390.891C207.854 391.047 207.641 391.125 207.359 391.125C207.078 391.125 206.865 391.047 206.719 390.891C206.578 390.734 206.508 390.539 206.508 390.305ZM211.758 392.547L211.805 393.609C212.451 392.797 213.294 392.391 214.336 392.391C216.122 392.391 217.023 393.398 217.039 395.414V401H215.594V395.406C215.589 394.797 215.448 394.346 215.172 394.055C214.901 393.763 214.477 393.617 213.898 393.617C213.43 393.617 213.018 393.742 212.664 393.992C212.31 394.242 212.034 394.57 211.836 394.977V401H210.391V392.547H211.758ZM218.875 396.703C218.875 395.385 219.18 394.339 219.789 393.562C220.398 392.781 221.206 392.391 222.211 392.391C223.242 392.391 224.047 392.755 224.625 393.484L224.695 392.547H226.016V400.797C226.016 401.891 225.69 402.753 225.039 403.383C224.393 404.013 223.523 404.328 222.43 404.328C221.82 404.328 221.224 404.198 220.641 403.938C220.057 403.677 219.612 403.32 219.305 402.867L220.055 402C220.674 402.766 221.432 403.148 222.328 403.148C223.031 403.148 223.578 402.951 223.969 402.555C224.365 402.159 224.562 401.602 224.562 400.883V400.156C223.984 400.823 223.195 401.156 222.195 401.156C221.206 401.156 220.404 400.758 219.789 399.961C219.18 399.164 218.875 398.078 218.875 396.703ZM220.328 396.867C220.328 397.82 220.523 398.57 220.914 399.117C221.305 399.659 221.852 399.93 222.555 399.93C223.466 399.93 224.135 399.516 224.562 398.688V394.828C224.12 394.021 223.456 393.617 222.57 393.617C221.867 393.617 221.318 393.891 220.922 394.438C220.526 394.984 220.328 395.794 220.328 396.867ZM233.125 398.758C233.125 398.367 232.977 398.065 232.68 397.852C232.388 397.633 231.875 397.445 231.141 397.289C230.411 397.133 229.831 396.945 229.398 396.727C228.971 396.508 228.654 396.247 228.445 395.945C228.242 395.643 228.141 395.284 228.141 394.867C228.141 394.174 228.432 393.589 229.016 393.109C229.604 392.63 230.354 392.391 231.266 392.391C232.224 392.391 233 392.638 233.594 393.133C234.193 393.628 234.492 394.26 234.492 395.031H233.039C233.039 394.635 232.87 394.294 232.531 394.008C232.198 393.721 231.776 393.578 231.266 393.578C230.74 393.578 230.328 393.693 230.031 393.922C229.734 394.151 229.586 394.451 229.586 394.82C229.586 395.169 229.724 395.432 230 395.609C230.276 395.786 230.773 395.956 231.492 396.117C232.216 396.279 232.802 396.471 233.25 396.695C233.698 396.919 234.029 397.19 234.242 397.508C234.461 397.82 234.57 398.203 234.57 398.656C234.57 399.411 234.268 400.018 233.664 400.477C233.06 400.93 232.276 401.156 231.312 401.156C230.635 401.156 230.036 401.036 229.516 400.797C228.995 400.557 228.586 400.224 228.289 399.797C227.997 399.365 227.852 398.898 227.852 398.398H229.297C229.323 398.883 229.516 399.268 229.875 399.555C230.24 399.836 230.719 399.977 231.312 399.977C231.859 399.977 232.297 399.867 232.625 399.648C232.958 399.424 233.125 399.128 233.125 398.758ZM244.508 393.844C244.289 393.807 244.052 393.789 243.797 393.789C242.849 393.789 242.206 394.193 241.867 395V401H240.422V392.547H241.828L241.852 393.523C242.326 392.768 242.997 392.391 243.867 392.391C244.148 392.391 244.362 392.427 244.508 392.5V393.844ZM247.414 401H245.969V392.547H247.414V401ZM245.852 390.305C245.852 390.07 245.922 389.872 246.062 389.711C246.208 389.549 246.422 389.469 246.703 389.469C246.984 389.469 247.198 389.549 247.344 389.711C247.49 389.872 247.562 390.07 247.562 390.305C247.562 390.539 247.49 390.734 247.344 390.891C247.198 391.047 246.984 391.125 246.703 391.125C246.422 391.125 246.208 391.047 246.062 390.891C245.922 390.734 245.852 390.539 245.852 390.305ZM249.391 396.703C249.391 395.385 249.695 394.339 250.305 393.562C250.914 392.781 251.721 392.391 252.727 392.391C253.758 392.391 254.562 392.755 255.141 393.484L255.211 392.547H256.531V400.797C256.531 401.891 256.206 402.753 255.555 403.383C254.909 404.013 254.039 404.328 252.945 404.328C252.336 404.328 251.74 404.198 251.156 403.938C250.573 403.677 250.128 403.32 249.82 402.867L250.57 402C251.19 402.766 251.948 403.148 252.844 403.148C253.547 403.148 254.094 402.951 254.484 402.555C254.88 402.159 255.078 401.602 255.078 400.883V400.156C254.5 400.823 253.711 401.156 252.711 401.156C251.721 401.156 250.919 400.758 250.305 399.961C249.695 399.164 249.391 398.078 249.391 396.703ZM250.844 396.867C250.844 397.82 251.039 398.57 251.43 399.117C251.82 399.659 252.367 399.93 253.07 399.93C253.982 399.93 254.651 399.516 255.078 398.688V394.828C254.635 394.021 253.971 393.617 253.086 393.617C252.383 393.617 251.833 393.891 251.438 394.438C251.042 394.984 250.844 395.794 250.844 396.867ZM260.164 393.57C260.805 392.784 261.638 392.391 262.664 392.391C264.451 392.391 265.352 393.398 265.367 395.414V401H263.922V395.406C263.917 394.797 263.776 394.346 263.5 394.055C263.229 393.763 262.805 393.617 262.227 393.617C261.758 393.617 261.346 393.742 260.992 393.992C260.638 394.242 260.362 394.57 260.164 394.977V401H258.719V389H260.164V393.57ZM269.492 390.5V392.547H271.07V393.664H269.492V398.906C269.492 399.245 269.562 399.5 269.703 399.672C269.844 399.839 270.083 399.922 270.422 399.922C270.589 399.922 270.818 399.891 271.109 399.828V401C270.729 401.104 270.359 401.156 270 401.156C269.354 401.156 268.867 400.961 268.539 400.57C268.211 400.18 268.047 399.625 268.047 398.906V393.664H266.508V392.547H268.047V390.5H269.492ZM284.219 399.008L285.844 392.547H287.289L284.828 401H283.656L281.602 394.594L279.602 401H278.43L275.977 392.547H277.414L279.078 398.875L281.047 392.547H282.211L284.219 399.008ZM292.273 401.156C291.128 401.156 290.195 400.781 289.477 400.031C288.758 399.276 288.398 398.268 288.398 397.008V396.742C288.398 395.904 288.557 395.156 288.875 394.5C289.198 393.839 289.646 393.323 290.219 392.953C290.797 392.578 291.422 392.391 292.094 392.391C293.193 392.391 294.047 392.753 294.656 393.477C295.266 394.201 295.57 395.237 295.57 396.586V397.188H289.844C289.865 398.021 290.107 398.695 290.57 399.211C291.039 399.721 291.633 399.977 292.352 399.977C292.862 399.977 293.294 399.872 293.648 399.664C294.003 399.456 294.312 399.18 294.578 398.836L295.461 399.523C294.753 400.612 293.69 401.156 292.273 401.156ZM292.094 393.578C291.51 393.578 291.021 393.792 290.625 394.219C290.229 394.641 289.984 395.234 289.891 396H294.125V395.891C294.083 395.156 293.885 394.589 293.531 394.188C293.177 393.781 292.698 393.578 292.094 393.578ZM302.586 392.547L302.633 393.609C303.279 392.797 304.122 392.391 305.164 392.391C306.951 392.391 307.852 393.398 307.867 395.414V401H306.422V395.406C306.417 394.797 306.276 394.346 306 394.055C305.729 393.763 305.305 393.617 304.727 393.617C304.258 393.617 303.846 393.742 303.492 393.992C303.138 394.242 302.862 394.57 302.664 394.977V401H301.219V392.547H302.586ZM313.555 401.156C312.409 401.156 311.477 400.781 310.758 400.031C310.039 399.276 309.68 398.268 309.68 397.008V396.742C309.68 395.904 309.839 395.156 310.156 394.5C310.479 393.839 310.927 393.323 311.5 392.953C312.078 392.578 312.703 392.391 313.375 392.391C314.474 392.391 315.328 392.753 315.938 393.477C316.547 394.201 316.852 395.237 316.852 396.586V397.188H311.125C311.146 398.021 311.388 398.695 311.852 399.211C312.32 399.721 312.914 399.977 313.633 399.977C314.143 399.977 314.576 399.872 314.93 399.664C315.284 399.456 315.594 399.18 315.859 398.836L316.742 399.523C316.034 400.612 314.971 401.156 313.555 401.156ZM313.375 393.578C312.792 393.578 312.302 393.792 311.906 394.219C311.51 394.641 311.266 395.234 311.172 396H315.406V395.891C315.365 395.156 315.167 394.589 314.812 394.188C314.458 393.781 313.979 393.578 313.375 393.578ZM322.039 401.156C320.893 401.156 319.961 400.781 319.242 400.031C318.523 399.276 318.164 398.268 318.164 397.008V396.742C318.164 395.904 318.323 395.156 318.641 394.5C318.964 393.839 319.411 393.323 319.984 392.953C320.562 392.578 321.188 392.391 321.859 392.391C322.958 392.391 323.812 392.753 324.422 393.477C325.031 394.201 325.336 395.237 325.336 396.586V397.188H319.609C319.63 398.021 319.872 398.695 320.336 399.211C320.805 399.721 321.398 399.977 322.117 399.977C322.628 399.977 323.06 399.872 323.414 399.664C323.768 399.456 324.078 399.18 324.344 398.836L325.227 399.523C324.518 400.612 323.456 401.156 322.039 401.156ZM321.859 393.578C321.276 393.578 320.786 393.792 320.391 394.219C319.995 394.641 319.75 395.234 319.656 396H323.891V395.891C323.849 395.156 323.651 394.589 323.297 394.188C322.943 393.781 322.464 393.578 321.859 393.578ZM326.664 396.703C326.664 395.406 326.971 394.365 327.586 393.578C328.201 392.786 329.005 392.391 330 392.391C330.99 392.391 331.773 392.729 332.352 393.406V389H333.797V401H332.469L332.398 400.094C331.82 400.802 331.016 401.156 329.984 401.156C329.005 401.156 328.206 400.755 327.586 399.953C326.971 399.151 326.664 398.104 326.664 396.812V396.703ZM328.109 396.867C328.109 397.826 328.307 398.576 328.703 399.117C329.099 399.659 329.646 399.93 330.344 399.93C331.26 399.93 331.93 399.518 332.352 398.695V394.812C331.919 394.016 331.255 393.617 330.359 393.617C329.651 393.617 329.099 393.891 328.703 394.438C328.307 394.984 328.109 395.794 328.109 396.867ZM344.938 398.758C344.938 398.367 344.789 398.065 344.492 397.852C344.201 397.633 343.688 397.445 342.953 397.289C342.224 397.133 341.643 396.945 341.211 396.727C340.784 396.508 340.466 396.247 340.258 395.945C340.055 395.643 339.953 395.284 339.953 394.867C339.953 394.174 340.245 393.589 340.828 393.109C341.417 392.63 342.167 392.391 343.078 392.391C344.036 392.391 344.812 392.638 345.406 393.133C346.005 393.628 346.305 394.26 346.305 395.031H344.852C344.852 394.635 344.682 394.294 344.344 394.008C344.01 393.721 343.589 393.578 343.078 393.578C342.552 393.578 342.141 393.693 341.844 393.922C341.547 394.151 341.398 394.451 341.398 394.82C341.398 395.169 341.536 395.432 341.812 395.609C342.089 395.786 342.586 395.956 343.305 396.117C344.029 396.279 344.615 396.471 345.062 396.695C345.51 396.919 345.841 397.19 346.055 397.508C346.273 397.82 346.383 398.203 346.383 398.656C346.383 399.411 346.081 400.018 345.477 400.477C344.872 400.93 344.089 401.156 343.125 401.156C342.448 401.156 341.849 401.036 341.328 400.797C340.807 400.557 340.398 400.224 340.102 399.797C339.81 399.365 339.664 398.898 339.664 398.398H341.109C341.135 398.883 341.328 399.268 341.688 399.555C342.052 399.836 342.531 399.977 343.125 399.977C343.672 399.977 344.109 399.867 344.438 399.648C344.771 399.424 344.938 399.128 344.938 398.758ZM347.883 396.695C347.883 395.867 348.044 395.122 348.367 394.461C348.695 393.799 349.148 393.289 349.727 392.93C350.31 392.57 350.974 392.391 351.719 392.391C352.87 392.391 353.799 392.789 354.508 393.586C355.221 394.383 355.578 395.443 355.578 396.766V396.867C355.578 397.69 355.419 398.43 355.102 399.086C354.789 399.737 354.339 400.245 353.75 400.609C353.167 400.974 352.495 401.156 351.734 401.156C350.589 401.156 349.659 400.758 348.945 399.961C348.237 399.164 347.883 398.109 347.883 396.797V396.695ZM349.336 396.867C349.336 397.805 349.552 398.557 349.984 399.125C350.422 399.693 351.005 399.977 351.734 399.977C352.469 399.977 353.052 399.69 353.484 399.117C353.917 398.539 354.133 397.732 354.133 396.695C354.133 395.768 353.911 395.018 353.469 394.445C353.031 393.867 352.448 393.578 351.719 393.578C351.005 393.578 350.43 393.862 349.992 394.43C349.555 394.997 349.336 395.81 349.336 396.867ZM358.75 392.547L358.789 393.484C359.409 392.755 360.245 392.391 361.297 392.391C362.479 392.391 363.284 392.844 363.711 393.75C363.992 393.344 364.357 393.016 364.805 392.766C365.258 392.516 365.792 392.391 366.406 392.391C368.26 392.391 369.203 393.372 369.234 395.336V401H367.789V395.422C367.789 394.818 367.651 394.367 367.375 394.07C367.099 393.768 366.635 393.617 365.984 393.617C365.448 393.617 365.003 393.779 364.648 394.102C364.294 394.419 364.089 394.849 364.031 395.391V401H362.578V395.461C362.578 394.232 361.977 393.617 360.773 393.617C359.826 393.617 359.177 394.021 358.828 394.828V401H357.383V392.547H358.75ZM374.93 401.156C373.784 401.156 372.852 400.781 372.133 400.031C371.414 399.276 371.055 398.268 371.055 397.008V396.742C371.055 395.904 371.214 395.156 371.531 394.5C371.854 393.839 372.302 393.323 372.875 392.953C373.453 392.578 374.078 392.391 374.75 392.391C375.849 392.391 376.703 392.753 377.312 393.477C377.922 394.201 378.227 395.237 378.227 396.586V397.188H372.5C372.521 398.021 372.763 398.695 373.227 399.211C373.695 399.721 374.289 399.977 375.008 399.977C375.518 399.977 375.951 399.872 376.305 399.664C376.659 399.456 376.969 399.18 377.234 398.836L378.117 399.523C377.409 400.612 376.346 401.156 374.93 401.156ZM374.75 393.578C374.167 393.578 373.677 393.792 373.281 394.219C372.885 394.641 372.641 395.234 372.547 396H376.781V395.891C376.74 395.156 376.542 394.589 376.188 394.188C375.833 393.781 375.354 393.578 374.75 393.578ZM385.836 390.5V392.547H387.414V393.664H385.836V398.906C385.836 399.245 385.906 399.5 386.047 399.672C386.188 399.839 386.427 399.922 386.766 399.922C386.932 399.922 387.161 399.891 387.453 399.828V401C387.073 401.104 386.703 401.156 386.344 401.156C385.698 401.156 385.211 400.961 384.883 400.57C384.555 400.18 384.391 399.625 384.391 398.906V393.664H382.852V392.547H384.391V390.5H385.836ZM390.68 401H389.234V392.547H390.68V401ZM389.117 390.305C389.117 390.07 389.188 389.872 389.328 389.711C389.474 389.549 389.688 389.469 389.969 389.469C390.25 389.469 390.464 389.549 390.609 389.711C390.755 389.872 390.828 390.07 390.828 390.305C390.828 390.539 390.755 390.734 390.609 390.891C390.464 391.047 390.25 391.125 389.969 391.125C389.688 391.125 389.474 391.047 389.328 390.891C389.188 390.734 389.117 390.539 389.117 390.305ZM394.359 392.547L394.398 393.484C395.018 392.755 395.854 392.391 396.906 392.391C398.089 392.391 398.893 392.844 399.32 393.75C399.602 393.344 399.966 393.016 400.414 392.766C400.867 392.516 401.401 392.391 402.016 392.391C403.87 392.391 404.812 393.372 404.844 395.336V401H403.398V395.422C403.398 394.818 403.26 394.367 402.984 394.07C402.708 393.768 402.245 393.617 401.594 393.617C401.057 393.617 400.612 393.779 400.258 394.102C399.904 394.419 399.698 394.849 399.641 395.391V401H398.188V395.461C398.188 394.232 397.586 393.617 396.383 393.617C395.435 393.617 394.786 394.021 394.438 394.828V401H392.992V392.547H394.359ZM410.539 401.156C409.393 401.156 408.461 400.781 407.742 400.031C407.023 399.276 406.664 398.268 406.664 397.008V396.742C406.664 395.904 406.823 395.156 407.141 394.5C407.464 393.839 407.911 393.323 408.484 392.953C409.062 392.578 409.688 392.391 410.359 392.391C411.458 392.391 412.312 392.753 412.922 393.477C413.531 394.201 413.836 395.237 413.836 396.586V397.188H408.109C408.13 398.021 408.372 398.695 408.836 399.211C409.305 399.721 409.898 399.977 410.617 399.977C411.128 399.977 411.56 399.872 411.914 399.664C412.268 399.456 412.578 399.18 412.844 398.836L413.727 399.523C413.018 400.612 411.956 401.156 410.539 401.156ZM410.359 393.578C409.776 393.578 409.286 393.792 408.891 394.219C408.495 394.641 408.25 395.234 408.156 396H412.391V395.891C412.349 395.156 412.151 394.589 411.797 394.188C411.443 393.781 410.964 393.578 410.359 393.578ZM415.547 400.242C415.547 399.992 415.62 399.784 415.766 399.617C415.917 399.451 416.141 399.367 416.438 399.367C416.734 399.367 416.958 399.451 417.109 399.617C417.266 399.784 417.344 399.992 417.344 400.242C417.344 400.482 417.266 400.682 417.109 400.844C416.958 401.005 416.734 401.086 416.438 401.086C416.141 401.086 415.917 401.005 415.766 400.844C415.62 400.682 415.547 400.482 415.547 400.242Z",
  fill: "black",
  fillOpacity: 0.6
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M408.464 40.7084C405.713 42.1842 402.289 41.1503 400.813 38.399C399.338 35.6476 400.368 32.219 403.12 30.7432C405.872 29.268 409.303 30.3038 410.779 33.0551C412.254 35.8064 411.216 39.2326 408.464 40.7084ZM414.305 45.0641L417.944 39.1993L416.147 38.0862C415.619 37.7593 415.333 37.1617 415.385 36.5425C415.415 36.2007 415.426 35.8559 415.419 35.5104C415.404 34.8912 415.729 34.3146 416.275 34.0217L418.137 33.023L414.874 26.9388L413.012 27.9368C412.466 28.2298 411.806 28.1809 411.297 27.8262C411.014 27.6291 410.721 27.4474 410.42 27.283C409.875 26.9845 409.535 26.4153 409.556 25.7942L409.622 23.6825L402.724 23.4681L402.659 25.5878C402.641 26.2095 402.26 26.7503 401.698 27.0154C401.545 27.0877 401.394 27.1637 401.244 27.244C401.094 27.3244 400.946 27.4084 400.802 27.4956C400.273 27.8157 399.615 27.8342 399.089 27.5086L397.279 26.3875L393.642 32.2529L395.441 33.3697C395.968 33.6978 396.254 34.2954 396.201 34.9147C396.171 35.2558 396.16 35.5988 396.167 35.9424C396.18 36.5616 395.856 37.1376 395.311 37.4299L393.448 38.4286L396.711 44.5134L398.574 43.5148C399.12 43.2218 399.778 43.2706 400.287 43.6241C400.569 43.8207 400.861 44.0005 401.161 44.1643C401.706 44.4621 402.047 45.0313 402.028 45.6524L401.962 47.7697L408.862 47.9841L408.927 45.8662C408.946 45.2464 409.326 44.7075 409.886 44.443C410.04 44.3707 410.192 44.2934 410.344 44.2125C410.493 44.1321 410.64 44.0481 410.785 43.961C411.318 43.6396 411.979 43.6211 412.507 43.9492L414.305 45.0641Z",
  fill: "#C5D5E6"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M99.8213 173.671C94.9632 173.671 91.0247 169.737 91.0247 164.878C91.0247 160.02 94.9632 156.082 99.8213 156.082C104.679 156.082 108.618 160.02 108.618 164.878C108.618 169.737 104.679 173.671 99.8213 173.671ZM99.8213 146.047C89.4185 146.047 80.9902 154.476 80.9902 164.878C80.9902 175.277 89.4185 183.71 99.8213 183.71C110.219 183.71 118.652 175.277 118.652 164.878C118.652 154.476 110.219 146.047 99.8213 146.047Z",
  fill: "#C5D5E6"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M103.442 146.828H96.2003L96.6008 141.702H103.042L103.442 146.828Z",
  fill: "#C5D5E6"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M89.6584 149.268L84.5377 154.389L81.1962 150.48L85.7508 145.926L89.6584 149.268Z",
  fill: "#C5D5E6"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M81.6371 160.74V167.982L76.5107 167.581V161.14L81.6371 160.74Z",
  fill: "#C5D5E6"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M84.0771 174.523L89.1979 179.644L85.2896 182.985L80.7356 178.431L84.0771 174.523Z",
  fill: "#C5D5E6"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M95.5486 182.545H102.79L102.39 187.67H95.949L95.5486 182.545Z",
  fill: "#C5D5E6"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M109.332 180.105L114.453 174.984L117.795 178.892L113.24 183.446L109.332 180.105Z",
  fill: "#C5D5E6"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M117.354 168.633V161.391L122.48 161.792V168.233L117.354 168.633Z",
  fill: "#C5D5E6"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M114.914 154.849L109.793 149.728L113.701 146.387L118.255 150.942L114.914 154.849Z",
  fill: "#C5D5E6"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M446.331 80.815C441.473 80.815 437.534 76.8808 437.534 72.0227C437.534 67.1646 441.473 63.2261 446.331 63.2261C451.188 63.2261 455.127 67.1646 455.127 72.0227C455.127 76.8808 451.188 80.815 446.331 80.815ZM446.331 53.1916C435.928 53.1916 427.499 61.6199 427.499 72.0227C427.499 82.4205 435.928 90.8538 446.331 90.8538C456.729 90.8538 465.162 82.4205 465.162 72.0227C465.162 61.6199 456.729 53.1916 446.331 53.1916Z",
  fill: "#C5D5E6"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M449.951 53.9722H442.709L443.11 48.8465H449.551L449.951 53.9722Z",
  fill: "#C5D5E6"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M436.167 56.4121L431.047 61.5328L427.705 57.6246L432.26 53.0706L436.167 56.4121Z",
  fill: "#C5D5E6"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M428.146 67.8838V75.1255L423.02 74.725V68.2842L428.146 67.8838Z",
  fill: "#C5D5E6"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M430.586 81.6675L435.707 86.7882L431.799 90.1298L427.245 85.5751L430.586 81.6675Z",
  fill: "#C5D5E6"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M442.058 89.6888H449.299L448.899 94.8151H442.458L442.058 89.6888Z",
  fill: "#C5D5E6"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M455.841 87.2488L460.962 82.1281L464.304 86.0363L459.749 90.5903L455.841 87.2488Z",
  fill: "#C5D5E6"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M463.863 75.7771V68.5354L468.989 68.9358V75.3766L463.863 75.7771Z",
  fill: "#C5D5E6"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M461.423 61.9935L456.303 56.8728L460.21 53.5313L464.764 58.0859L461.423 61.9935Z",
  fill: "#C5D5E6"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M396.737 182.567L396.131 186.3L395.476 190.311L389.511 226.889H379.755L385.72 190.311L386.374 186.3L386.981 182.567H396.737Z",
  fill: "#ECECEC"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M395.324 182.567C394.81 186.273 394.257 189.971 393.699 193.669L391.979 204.757L390.175 215.832L389.245 221.364L388.277 226.891L389.07 221.336L389.902 215.788L391.622 204.7L393.425 193.626C394.042 189.937 394.663 186.249 395.324 182.567Z",
  fill: "#C8C8C8"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M396.13 186.3L395.476 190.311H385.72L386.374 186.3H396.13Z",
  fill: "#C8C8C8"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M444.899 182.567L445.506 186.3L446.16 190.311L452.126 226.889H461.882L455.916 190.311L455.263 186.3L454.655 182.567H444.899Z",
  fill: "#ECECEC"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M446.343 182.567C446.857 186.273 447.41 189.971 447.969 193.669L449.688 204.757L451.492 215.832L452.423 221.364L453.39 226.891L452.597 221.336L451.766 215.788L450.045 204.7L448.242 193.626C447.626 189.937 447.004 186.249 446.343 182.567Z",
  fill: "#C8C8C8"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M445.506 186.3H455.263L455.916 190.311H446.161L445.506 186.3Z",
  fill: "#C8C8C8"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M396.382 172.277H388.646L389.608 165.067H395.42L396.382 172.277Z",
  fill: "#C8C8C8"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M399.723 159.914C399.723 163.895 396.495 167.122 392.514 167.122C388.533 167.122 385.305 163.895 385.305 159.914C385.305 155.932 388.533 152.705 392.514 152.705C396.495 152.705 399.723 155.932 399.723 159.914Z",
  fill: "#DCDCDC"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M397.994 159.914C397.994 162.94 395.54 165.393 392.514 165.393C389.487 165.393 387.034 162.94 387.034 159.914C387.034 156.887 389.487 154.434 392.514 154.434C395.54 154.434 397.994 156.887 397.994 159.914Z",
  fill: "white"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M397.095 159.597C396.998 158.257 396.317 157.025 395.305 156.233C394.291 155.438 392.948 155.07 391.62 155.268C390.336 155.46 389.169 156.222 388.452 157.328C387.726 158.434 387.48 159.885 387.874 161.281C388.191 162.425 388.99 163.417 390.014 163.989C391.036 164.572 392.259 164.751 393.368 164.505C394.485 164.271 395.491 163.645 396.182 162.782C396.879 161.925 397.296 160.843 397.341 159.73C397.343 159.676 397.325 159.632 397.297 159.631C397.271 159.631 397.247 159.671 397.244 159.725C397.226 160.177 397.127 160.621 396.988 161.046C396.839 161.47 396.631 161.867 396.383 162.236C396.126 162.6 395.823 162.929 395.485 163.222C395.141 163.509 394.759 163.755 394.348 163.958C393.185 164.515 391.8 164.555 390.607 164.047C389.415 163.549 388.456 162.516 388.069 161.263C387.655 159.938 387.859 158.521 388.549 157.427C389.234 156.336 390.379 155.58 391.633 155.399C393.364 155.15 395.113 155.785 396.173 157.206C396.428 157.556 396.629 157.941 396.785 158.345C396.933 158.752 397.024 159.18 397.072 159.618C397.075 159.631 397.082 159.635 397.088 159.631C397.095 159.626 397.098 159.611 397.095 159.597Z",
  fill: "#ECECEC"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M396.453 159.602C396.357 158.45 395.766 157.406 394.9 156.731C394.031 156.055 392.893 155.739 391.753 155.895C390.653 156.048 389.64 156.693 389.01 157.643C388.374 158.59 388.148 159.849 388.479 161.067C388.744 162.065 389.441 162.937 390.336 163.435C391.228 163.941 392.296 164.094 393.262 163.873C394.231 163.662 395.101 163.114 395.697 162.362C396.298 161.615 396.656 160.682 396.699 159.716C396.701 159.67 396.683 159.632 396.655 159.631C396.629 159.631 396.606 159.666 396.603 159.713C396.522 161.292 395.517 162.679 394.1 163.366C393.103 163.855 391.897 163.898 390.864 163.459C389.831 163.031 388.998 162.13 388.672 161.044C388.322 159.895 388.509 158.67 389.111 157.738C389.708 156.804 390.699 156.168 391.767 156.026C393.246 155.834 394.72 156.357 395.64 157.562C395.86 157.861 396.033 158.187 396.171 158.531C396.301 158.878 396.383 159.242 396.431 159.62C396.434 159.631 396.441 159.635 396.447 159.631C396.454 159.626 396.456 159.614 396.453 159.602Z",
  fill: "#ECECEC"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M395.811 159.606C395.715 158.642 395.216 157.788 394.495 157.228C393.772 156.673 392.839 156.408 391.885 156.523C390.969 156.638 390.111 157.165 389.569 157.958C389.022 158.746 388.816 159.813 389.083 160.854C389.298 161.706 389.893 162.457 390.659 162.881C391.421 163.311 392.333 163.436 393.155 163.24C393.978 163.054 394.712 162.583 395.213 161.942C395.717 161.304 396.017 160.521 396.057 159.703C396.06 159.664 396.041 159.632 396.014 159.631C395.988 159.631 395.964 159.66 395.962 159.7C395.883 161.031 395.037 162.182 393.853 162.774C393.021 163.195 391.995 163.241 391.123 162.872C390.247 162.513 389.539 161.743 389.274 160.824C388.989 159.851 389.159 158.819 389.672 158.048C390.183 157.273 391.019 156.756 391.902 156.653C392.521 156.587 393.119 156.656 393.669 156.864C394.219 157.074 394.721 157.429 395.106 157.92C395.291 158.165 395.438 158.433 395.557 158.717C395.669 159.004 395.741 159.306 395.789 159.621C395.792 159.63 395.799 159.635 395.806 159.631C395.812 159.627 395.815 159.617 395.811 159.606Z",
  fill: "#ECECEC"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M395.17 159.611C395.073 158.834 394.665 158.169 394.091 157.726C393.513 157.291 392.785 157.076 392.017 157.152C391.287 157.226 390.582 157.636 390.128 158.273C389.67 158.902 389.483 159.778 389.689 160.639C389.852 161.347 390.344 161.978 390.981 162.326C391.613 162.68 392.371 162.778 393.048 162.607C393.725 162.446 394.323 162.052 394.728 161.522C395.135 160.994 395.378 160.36 395.416 159.69C395.418 159.658 395.4 159.632 395.372 159.63C395.346 159.63 395.323 159.654 395.32 159.687C395.245 160.769 394.556 161.684 393.606 162.181C392.939 162.534 392.094 162.584 391.38 162.285C390.664 161.994 390.081 161.356 389.877 160.604C389.656 159.808 389.809 158.968 390.234 158.359C390.657 157.742 391.338 157.343 392.037 157.28C392.527 157.242 392.996 157.299 393.428 157.458C393.859 157.619 394.26 157.892 394.573 158.276C394.723 158.468 394.842 158.679 394.943 158.903C395.036 159.13 395.1 159.369 395.147 159.624C395.151 159.63 395.158 159.635 395.164 159.63C395.171 159.627 395.173 159.62 395.17 159.611Z",
  fill: "#ECECEC"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M452.823 172.277H445.088L446.049 165.067H451.862L452.823 172.277Z",
  fill: "#C8C8C8"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M456.164 159.914C456.164 163.895 452.936 167.122 448.955 167.122C444.974 167.122 441.746 163.895 441.746 159.914C441.746 155.932 444.974 152.705 448.955 152.705C452.936 152.705 456.164 155.932 456.164 159.914Z",
  fill: "#DCDCDC"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M454.436 159.914C454.436 162.94 451.982 165.393 448.955 165.393C445.928 165.393 443.476 162.94 443.476 159.914C443.476 156.887 445.928 154.434 448.955 154.434C451.982 154.434 454.436 156.887 454.436 159.914Z",
  fill: "white"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M453.537 159.597C453.44 158.257 452.759 157.025 451.747 156.233C450.732 155.438 449.39 155.07 448.062 155.268C446.777 155.46 445.611 156.222 444.893 157.328C444.167 158.434 443.921 159.885 444.315 161.281C444.633 162.425 445.432 163.417 446.455 163.989C447.477 164.572 448.701 164.751 449.81 164.505C450.926 164.271 451.932 163.645 452.624 162.782C453.321 161.925 453.738 160.843 453.782 159.73C453.784 159.676 453.766 159.632 453.739 159.631C453.713 159.631 453.689 159.671 453.686 159.725C453.668 160.177 453.569 160.621 453.43 161.046C453.281 161.47 453.073 161.867 452.825 162.236C452.567 162.6 452.264 162.929 451.927 163.222C451.582 163.509 451.201 163.755 450.789 163.958C449.627 164.515 448.241 164.555 447.048 164.047C445.857 163.549 444.897 162.516 444.511 161.263C444.096 159.938 444.301 158.521 444.99 157.427C445.675 156.336 446.821 155.58 448.075 155.399C449.806 155.15 451.554 155.785 452.615 157.206C452.87 157.556 453.071 157.941 453.226 158.345C453.375 158.752 453.466 159.18 453.514 159.618C453.517 159.631 453.524 159.635 453.53 159.631C453.537 159.626 453.539 159.611 453.537 159.597Z",
  fill: "#ECECEC"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M452.894 159.602C452.798 158.45 452.208 157.406 451.341 156.731C450.473 156.055 449.335 155.739 448.194 155.895C447.094 156.048 446.082 156.693 445.452 157.643C444.815 158.59 444.589 159.849 444.92 161.067C445.186 162.065 445.883 162.937 446.778 163.435C447.67 163.941 448.738 164.094 449.703 163.873C450.673 163.662 451.543 163.114 452.139 162.362C452.739 161.615 453.098 160.682 453.14 159.716C453.143 159.67 453.124 159.632 453.097 159.631C453.071 159.631 453.047 159.666 453.045 159.713C452.963 161.292 451.959 162.679 450.542 163.366C449.544 163.855 448.339 163.898 447.306 163.459C446.273 163.031 445.439 162.13 445.113 161.044C444.763 159.895 444.951 158.67 445.552 157.738C446.15 156.804 447.14 156.168 448.209 156.026C449.688 155.834 451.161 156.357 452.082 157.562C452.302 157.861 452.475 158.187 452.613 158.531C452.742 158.878 452.824 159.242 452.872 159.62C452.875 159.631 452.882 159.635 452.889 159.631C452.895 159.626 452.898 159.614 452.894 159.602Z",
  fill: "#ECECEC"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M452.253 159.606C452.157 158.642 451.657 157.788 450.937 157.228C450.214 156.673 449.281 156.408 448.326 156.523C447.412 156.638 446.553 157.165 446.011 157.958C445.464 158.746 445.257 159.813 445.525 160.854C445.739 161.706 446.334 162.457 447.1 162.881C447.863 163.311 448.776 163.436 449.597 163.24C450.42 163.054 451.154 162.583 451.655 161.942C452.159 161.304 452.459 160.521 452.5 159.703C452.501 159.664 452.483 159.632 452.456 159.631C452.43 159.631 452.406 159.66 452.403 159.7C452.325 161.031 451.479 162.182 450.295 162.774C449.462 163.195 448.437 163.241 447.564 162.872C446.689 162.513 445.981 161.743 445.716 160.824C445.43 159.851 445.601 158.819 446.113 158.048C446.625 157.273 447.46 156.756 448.344 156.653C448.962 156.587 449.561 156.656 450.111 156.864C450.66 157.074 451.163 157.429 451.548 157.92C451.733 158.165 451.88 158.433 451.998 158.717C452.11 159.004 452.183 159.306 452.231 159.621C452.234 159.63 452.241 159.635 452.247 159.631C452.254 159.627 452.256 159.617 452.253 159.606Z",
  fill: "#ECECEC"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M451.611 159.611C451.515 158.834 451.107 158.169 450.532 157.726C449.955 157.291 449.227 157.076 448.458 157.152C447.729 157.226 447.023 157.636 446.57 158.273C446.112 158.902 445.925 159.778 446.13 160.639C446.294 161.347 446.786 161.978 447.423 162.326C448.055 162.68 448.813 162.778 449.49 162.607C450.167 162.446 450.764 162.052 451.17 161.522C451.577 160.994 451.82 160.36 451.858 159.69C451.86 159.658 451.841 159.632 451.814 159.63C451.788 159.63 451.765 159.654 451.762 159.687C451.686 160.769 450.998 161.684 450.048 162.181C449.38 162.534 448.535 162.584 447.822 162.285C447.105 161.994 446.523 161.356 446.319 160.604C446.098 159.808 446.252 158.968 446.675 158.359C447.099 157.742 447.78 157.343 448.478 157.28C448.969 157.242 449.437 157.299 449.869 157.458C450.3 157.619 450.702 157.892 451.015 158.276C451.165 158.468 451.284 158.679 451.385 158.903C451.477 159.13 451.541 159.369 451.589 159.624C451.592 159.63 451.599 159.635 451.606 159.63C451.612 159.627 451.615 159.62 451.611 159.611Z",
  fill: "#ECECEC"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M469.422 187.196H372.214V168.602H469.422V187.196Z",
  fill: "#DCDCDC"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M392.193 168.602L385.138 187.196H372.585L379.64 168.602H392.193Z",
  fill: "#ECECEC"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M417.927 168.602L410.872 187.196H398.314L405.37 168.602H417.927Z",
  fill: "#ECECEC"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M443.657 168.602L436.602 187.196H424.048L431.104 168.602H443.657Z",
  fill: "#ECECEC"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M469.39 168.602L462.335 187.196H449.777L456.833 168.602H469.39Z",
  fill: "#ECECEC"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M467.455 216.152H374.182V204.385H467.455V216.152Z",
  fill: "#DCDCDC"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M393.352 204.385L386.583 216.152H374.538L381.307 204.385H393.352Z",
  fill: "#ECECEC"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M418.045 204.385L411.275 216.152H399.226L405.995 204.385H418.045Z",
  fill: "#ECECEC"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M442.732 204.385L435.962 216.152H423.917L430.687 204.385H442.732Z",
  fill: "#ECECEC"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M467.424 204.385L460.655 216.152H448.605L455.374 204.385H467.424Z",
  fill: "#ECECEC"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M458.015 277.216C458.015 281.413 407.613 284.815 345.439 284.815C283.265 284.815 232.864 281.413 232.864 277.216C232.864 273.02 283.265 269.617 345.439 269.617C407.613 269.617 458.015 273.02 458.015 277.216Z",
  fill: "#ECECEC"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M391.424 220.688C391.424 225.106 387.842 228.688 383.424 228.688H162.075C157.657 228.688 154.075 225.106 154.075 220.688V77.9195C154.075 73.5012 157.657 69.9195 162.075 69.9195H383.424C387.842 69.9195 391.424 73.5012 391.424 77.9195V220.688Z",
  fill: "#DCDCDC"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M389.699 218.751C389.699 223.169 386.117 226.751 381.699 226.751H163.801C159.383 226.751 155.801 223.169 155.801 218.751V79.8557C155.801 75.4374 159.383 71.8557 163.801 71.8557H381.699C386.117 71.8557 389.699 75.4374 389.699 79.8557V218.751Z",
  fill: "#B0B0B0"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M422.337 240.593C422.337 242.745 420.593 244.49 418.441 244.49H127.059C124.907 244.49 123.162 242.745 123.162 240.593H422.337Z",
  fill: "#C8C8C8"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M123.163 240.593L153.382 228.955C153.84 228.778 154.328 228.687 154.819 228.687H390.68C391.172 228.687 391.659 228.778 392.118 228.955L422.338 240.593H123.163Z",
  fill: "#DCDCDC"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M156.837 236.37L176.785 228.687H368.714L388.664 236.37H156.837Z",
  fill: "#B0B0B0"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M376.656 215.039H168.844V83.5686H376.656V215.039Z",
  fill: "white"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M376.656 88.6276H168.844V83.5686H376.656V88.6276Z",
  fill: "#3E5C69"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M172.864 86.0981C172.864 86.7909 172.303 87.3527 171.61 87.3527C170.917 87.3527 170.355 86.7909 170.355 86.0981C170.355 85.4053 170.917 84.8436 171.61 84.8436C172.303 84.8436 172.864 85.4053 172.864 86.0981Z",
  fill: "#F6851F"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M177.988 86.0981C177.988 86.7909 177.426 87.3527 176.733 87.3527C176.04 87.3527 175.479 86.7909 175.479 86.0981C175.479 85.4053 176.04 84.8436 176.733 84.8436C177.426 84.8436 177.988 85.4053 177.988 86.0981Z",
  fill: "#ECECEC"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M183.111 86.0981C183.111 86.7909 182.549 87.3527 181.856 87.3527C181.164 87.3527 180.601 86.7909 180.601 86.0981C180.601 85.4053 181.164 84.8436 181.856 84.8436C182.549 84.8436 183.111 85.4053 183.111 86.0981Z",
  fill: "white"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M268.217 174.387H306.081V145.336H268.217V174.387Z",
  fill: "#ECECEC"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M271.985 151.689C271.526 154.111 273.609 156.194 276.031 155.735C277.383 155.478 278.475 154.388 278.731 153.035C279.19 150.613 277.107 148.53 274.685 148.989C273.332 149.246 272.242 150.337 271.985 151.689Z",
  fill: "white"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M280.708 168.128H306.08L293.394 152.493L280.708 168.128Z",
  fill: "#C8C8C8"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M268.217 168.142H290.717L279.467 157.96L268.217 168.142Z",
  fill: "#DCDCDC"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M306.081 174.387H268.217V168.128H306.081V174.387Z",
  fill: "#DCDCDC"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M207.545 147.729H179.104V145.336H207.545V147.729Z",
  fill: "#DCDCDC"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M261.41 153.281H179.104V150.888H261.41V153.281Z",
  fill: "#DCDCDC"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M261.41 158.546H179.104V156.153H261.41V158.546Z",
  fill: "#DCDCDC"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M261.41 163.81H179.104V161.417H261.41V163.81Z",
  fill: "#DCDCDC"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M261.41 169.074H179.104V166.682H261.41V169.074Z",
  fill: "#DCDCDC"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M261.41 174.339H179.104V171.946H261.41V174.339Z",
  fill: "#DCDCDC"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M276.09 104.765H247.649V98.3635H276.09V104.765Z",
  fill: "#DCDCDC"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M306.08 111.573H247.65V109.18H306.08V111.573Z",
  fill: "#DCDCDC"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M306.08 116.837H247.65V114.444H306.08V116.837Z",
  fill: "#DCDCDC"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M306.08 122.102H247.65V119.709H306.08V122.102Z",
  fill: "#DCDCDC"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M306.08 127.366H247.65V124.973H306.08V127.366Z",
  fill: "#DCDCDC"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M306.08 134.369H247.65V131.976H306.08V134.369Z",
  fill: "#DCDCDC"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M306.08 139.634H247.65V137.241H306.08V139.634Z",
  fill: "#DCDCDC"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M366.385 104.88H314.376V98.3634H366.385V104.88Z",
  fill: "#4C86B7"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M366.251 207.109H314.52V104.935H366.251V207.109Z",
  fill: "white"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M314.663 206.939H366.107V105.103H314.663V206.939ZM366.395 207.277H314.375V104.765H366.395V207.277Z",
  fill: "#DCDCDC"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M314.653 207.171L314.385 207.046L366.117 104.872L366.385 104.997L314.653 207.171Z",
  fill: "#DCDCDC"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M366.117 207.171L314.386 104.997L314.653 104.872L366.386 207.046L366.117 207.171Z",
  fill: "#DCDCDC"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M241.205 139.511L179.221 139.529L179.209 98.4861L241.192 98.4675L241.205 139.511Z",
  fill: "white"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M179.313 98.5903L179.325 139.425L241.101 139.407L241.088 98.5717L179.313 98.5903ZM179.116 139.633V139.53L179.105 98.382H179.209L241.296 98.3634L241.308 139.615H241.204L179.116 139.633Z",
  fill: "#DCDCDC"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M179.313 98.5903C184.528 101.892 189.707 105.247 194.881 108.611L210.365 118.759L225.775 129.018L233.455 134.187L241.101 139.407L233.299 134.423L225.532 129.387L210.048 119.238L194.638 108.978C189.515 105.538 184.397 102.091 179.313 98.5903Z",
  fill: "#DCDCDC"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M241.101 98.5903C236.017 102.091 230.899 105.538 225.775 108.978L210.365 119.238L194.882 129.387L187.114 134.423L179.313 139.407L186.958 134.187L194.638 129.018L210.048 118.759L225.532 108.611C230.706 105.247 235.886 101.892 241.101 98.5903Z",
  fill: "#DCDCDC"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M305.791 207.197H179.314V178.335H305.791V207.197Z",
  fill: "white"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M305.581 178.416H179.523V207.117H305.581V178.416ZM306 207.277H179.104V178.255H306V207.277Z",
  fill: "#DCDCDC"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M305.868 207.122L305.713 207.272L179.236 178.41L179.391 178.261L305.868 207.122Z",
  fill: "#DCDCDC"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  d: "M305.868 178.41L179.391 207.272L179.236 207.122L305.713 178.261L305.868 178.41Z",
  fill: "#DCDCDC"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  d: "M116.569 88.6069L115.204 87.3203L128.404 73.3164L129.769 74.6024L116.569 88.6069Z",
  fill: "#B0B0B0"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M129.408 89.4873H115.887V87.6123H129.408V89.4873Z",
  fill: "#3E5C69"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M129.408 74.8975H115.887V73.0225H129.408V74.8975Z",
  fill: "#3E5C69"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  d: "M128.404 88.6069L115.205 74.6024L116.569 73.3164L129.769 87.3203L128.404 88.6069Z",
  fill: "#3E5C69"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  d: "M116.569 103.197L115.204 101.91L128.404 87.9063L129.769 89.193L116.569 103.197Z",
  fill: "#B0B0B0"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  d: "M129.408 104.077H115.887V102.202H129.408V104.077Z",
  fill: "#3E5C69"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  d: "M129.408 89.4873H115.887V87.6123H129.408V89.4873Z",
  fill: "#3E5C69"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  d: "M128.404 103.197L115.205 89.193L116.569 87.9063L129.769 101.91L128.404 103.197Z",
  fill: "#3E5C69"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  d: "M116.569 117.787L115.204 116.501L128.404 102.496L129.769 103.783L116.569 117.787Z",
  fill: "#B0B0B0"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  d: "M129.408 118.667H115.887V116.792H129.408V118.667Z",
  fill: "#3E5C69"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  d: "M129.408 104.077H115.887V102.202H129.408V104.077Z",
  fill: "#3E5C69"
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  d: "M128.404 117.787L115.205 103.783L116.569 102.496L129.769 116.501L128.404 117.787Z",
  fill: "#3E5C69"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M116.569 132.377L115.204 131.091L128.404 117.087L129.769 118.373L116.569 132.377Z",
  fill: "#B0B0B0"
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  d: "M129.408 133.258H115.887V131.383H129.408V133.258Z",
  fill: "#3E5C69"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  d: "M129.408 118.667H115.887V116.792H129.408V118.667Z",
  fill: "#3E5C69"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  d: "M128.404 132.377L115.205 118.373L116.569 117.087L129.769 131.091L128.404 132.377Z",
  fill: "#3E5C69"
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  d: "M116.569 146.967L115.204 145.681L128.404 131.677L129.769 132.963L116.569 146.967Z",
  fill: "#B0B0B0"
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  d: "M129.408 147.847H115.887V145.972H129.408V147.847Z",
  fill: "#3E5C69"
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  d: "M129.408 133.258H115.887V131.383H129.408V133.258Z",
  fill: "#3E5C69"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  d: "M128.404 146.967L115.205 132.963L116.569 131.677L129.769 145.681L128.404 146.967Z",
  fill: "#3E5C69"
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  d: "M116.569 161.557L115.204 160.271L128.404 146.267L129.769 147.553L116.569 161.557Z",
  fill: "#B0B0B0"
});

var _ref116 = /*#__PURE__*/React.createElement("path", {
  d: "M129.408 162.437H115.887V160.562H129.408V162.437Z",
  fill: "#3E5C69"
});

var _ref117 = /*#__PURE__*/React.createElement("path", {
  d: "M129.408 147.847H115.887V145.972H129.408V147.847Z",
  fill: "#3E5C69"
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  d: "M128.404 161.557L115.205 147.553L116.569 146.267L129.769 160.271L128.404 161.557Z",
  fill: "#3E5C69"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  d: "M116.569 176.147L115.204 174.861L128.404 160.857L129.769 162.143L116.569 176.147Z",
  fill: "#B0B0B0"
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  d: "M129.408 177.027H115.887V175.152H129.408V177.027Z",
  fill: "#3E5C69"
});

var _ref121 = /*#__PURE__*/React.createElement("path", {
  d: "M129.408 162.437H115.887V160.562H129.408V162.437Z",
  fill: "#3E5C69"
});

var _ref122 = /*#__PURE__*/React.createElement("path", {
  d: "M128.404 176.147L115.205 162.143L116.569 160.857L129.769 174.861L128.404 176.147Z",
  fill: "#3E5C69"
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  d: "M116.569 190.737L115.204 189.451L128.404 175.447L129.769 176.734L116.569 190.737Z",
  fill: "#B0B0B0"
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  d: "M129.408 191.617H115.887V189.743H129.408V191.617Z",
  fill: "#3E5C69"
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  d: "M129.408 177.027H115.887V175.152H129.408V177.027Z",
  fill: "#3E5C69"
});

var _ref126 = /*#__PURE__*/React.createElement("path", {
  d: "M128.404 190.737L115.205 176.734L116.569 175.447L129.769 189.451L128.404 190.737Z",
  fill: "#3E5C69"
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  d: "M116.569 205.327L115.204 204.041L128.404 190.037L129.769 191.324L116.569 205.327Z",
  fill: "#B0B0B0"
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  d: "M129.408 206.208H115.887V204.333H129.408V206.208Z",
  fill: "#3E5C69"
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  d: "M129.408 191.617H115.887V189.743H129.408V191.617Z",
  fill: "#3E5C69"
});

var _ref130 = /*#__PURE__*/React.createElement("path", {
  d: "M128.404 205.327L115.205 191.324L116.569 190.037L129.769 204.041L128.404 205.327Z",
  fill: "#3E5C69"
});

var _ref131 = /*#__PURE__*/React.createElement("path", {
  d: "M116.569 219.917L115.204 218.631L128.404 204.627L129.769 205.914L116.569 219.917Z",
  fill: "#B0B0B0"
});

var _ref132 = /*#__PURE__*/React.createElement("path", {
  d: "M129.408 220.798H115.887V218.923H129.408V220.798Z",
  fill: "#3E5C69"
});

var _ref133 = /*#__PURE__*/React.createElement("path", {
  d: "M129.408 206.208H115.887V204.333H129.408V206.208Z",
  fill: "#3E5C69"
});

var _ref134 = /*#__PURE__*/React.createElement("path", {
  d: "M128.404 219.917L115.205 205.914L116.569 204.627L129.769 218.631L128.404 219.917Z",
  fill: "#3E5C69"
});

var _ref135 = /*#__PURE__*/React.createElement("path", {
  d: "M116.569 234.507L115.204 233.222L128.404 219.218L129.769 220.503L116.569 234.507Z",
  fill: "#B0B0B0"
});

var _ref136 = /*#__PURE__*/React.createElement("path", {
  d: "M129.408 235.388H115.887V233.513H129.408V235.388Z",
  fill: "#3E5C69"
});

var _ref137 = /*#__PURE__*/React.createElement("path", {
  d: "M129.408 220.798H115.887V218.923H129.408V220.798Z",
  fill: "#3E5C69"
});

var _ref138 = /*#__PURE__*/React.createElement("path", {
  d: "M128.404 234.507L115.205 220.503L116.569 219.218L129.769 233.222L128.404 234.507Z",
  fill: "#3E5C69"
});

var _ref139 = /*#__PURE__*/React.createElement("path", {
  d: "M112.612 233.317H132.117V241.812H112.612V233.317Z",
  fill: "#3E5C69"
});

var _ref140 = /*#__PURE__*/React.createElement("path", {
  d: "M112.612 73.7856H117.5V233.851H112.612V73.7856Z",
  fill: "#3E5C69"
});

var _ref141 = /*#__PURE__*/React.createElement("path", {
  d: "M127.229 73.7856H132.117V233.851H127.229V73.7856Z",
  fill: "#3E5C69"
});

var _ref142 = /*#__PURE__*/React.createElement("path", {
  d: "M260.594 72.6412L245.982 58.2462L122.67 35.2652L85.1922 58.3525L84.209 56.7555L122.302 33.2895L246.889 56.5071L261.909 71.3051L260.594 72.6412Z",
  fill: "#3E5C69"
});

var _ref143 = /*#__PURE__*/React.createElement("path", {
  d: "M137.54 60.2639L122.519 39.3891L108.144 60.233L105.057 58.1046L122.454 32.8779L140.584 58.0743L137.54 60.2639Z",
  fill: "#B0B0B0"
});

var _ref144 = /*#__PURE__*/React.createElement("path", {
  d: "M244.944 74.4684L230.939 61.2685L232.226 59.9046L246.23 73.1038L244.944 74.4684Z",
  fill: "#B0B0B0"
});

var _ref145 = /*#__PURE__*/React.createElement("path", {
  d: "M247.11 73.7863H245.235V60.265H247.11V73.7863Z",
  fill: "#3E5C69"
});

var _ref146 = /*#__PURE__*/React.createElement("path", {
  d: "M232.52 73.7863H230.645V60.265H232.52V73.7863Z",
  fill: "#3E5C69"
});

var _ref147 = /*#__PURE__*/React.createElement("path", {
  d: "M232.226 74.4684L230.939 73.1038L244.944 59.9046L246.23 61.2685L232.226 74.4684Z",
  fill: "#3E5C69"
});

var _ref148 = /*#__PURE__*/React.createElement("path", {
  d: "M230.354 74.4684L216.35 61.2685L217.636 59.9046L231.64 73.1038L230.354 74.4684Z",
  fill: "#B0B0B0"
});

var _ref149 = /*#__PURE__*/React.createElement("path", {
  d: "M232.52 73.7863H230.645V60.265H232.52V73.7863Z",
  fill: "#3E5C69"
});

var _ref150 = /*#__PURE__*/React.createElement("path", {
  d: "M217.93 73.7863H216.055V60.265H217.93V73.7863Z",
  fill: "#3E5C69"
});

var _ref151 = /*#__PURE__*/React.createElement("path", {
  d: "M217.636 74.4684L216.349 73.1038L230.354 59.9046L231.64 61.2685L217.636 74.4684Z",
  fill: "#3E5C69"
});

var _ref152 = /*#__PURE__*/React.createElement("path", {
  d: "M215.764 74.4684L201.76 61.2685L203.046 59.9046L217.05 73.1038L215.764 74.4684Z",
  fill: "#B0B0B0"
});

var _ref153 = /*#__PURE__*/React.createElement("path", {
  d: "M217.93 73.7863H216.055V60.265H217.93V73.7863Z",
  fill: "#3E5C69"
});

var _ref154 = /*#__PURE__*/React.createElement("path", {
  d: "M203.341 73.7863H201.466V60.265H203.341V73.7863Z",
  fill: "#3E5C69"
});

var _ref155 = /*#__PURE__*/React.createElement("path", {
  d: "M203.046 74.4684L201.76 73.1038L215.764 59.9046L217.05 61.2685L203.046 74.4684Z",
  fill: "#3E5C69"
});

var _ref156 = /*#__PURE__*/React.createElement("path", {
  d: "M201.174 74.4684L187.17 61.2685L188.456 59.9046L202.46 73.1038L201.174 74.4684Z",
  fill: "#B0B0B0"
});

var _ref157 = /*#__PURE__*/React.createElement("path", {
  d: "M203.341 73.7863H201.466V60.265H203.341V73.7863Z",
  fill: "#3E5C69"
});

var _ref158 = /*#__PURE__*/React.createElement("path", {
  d: "M188.75 73.7863H186.875V60.265H188.75V73.7863Z",
  fill: "#3E5C69"
});

var _ref159 = /*#__PURE__*/React.createElement("path", {
  d: "M188.456 74.4684L187.17 73.1038L201.174 59.9046L202.46 61.2685L188.456 74.4684Z",
  fill: "#3E5C69"
});

var _ref160 = /*#__PURE__*/React.createElement("path", {
  d: "M186.584 74.4684L172.579 61.2685L173.866 59.9046L187.87 73.1038L186.584 74.4684Z",
  fill: "#B0B0B0"
});

var _ref161 = /*#__PURE__*/React.createElement("path", {
  d: "M188.75 73.7863H186.875V60.265H188.75V73.7863Z",
  fill: "#3E5C69"
});

var _ref162 = /*#__PURE__*/React.createElement("path", {
  d: "M174.16 73.7863H172.285V60.265H174.16V73.7863Z",
  fill: "#3E5C69"
});

var _ref163 = /*#__PURE__*/React.createElement("path", {
  d: "M173.866 74.4684L172.579 73.1038L186.584 59.9046L187.87 61.2685L173.866 74.4684Z",
  fill: "#3E5C69"
});

var _ref164 = /*#__PURE__*/React.createElement("path", {
  d: "M171.993 74.4684L157.989 61.2685L159.275 59.9046L173.28 73.1038L171.993 74.4684Z",
  fill: "#B0B0B0"
});

var _ref165 = /*#__PURE__*/React.createElement("path", {
  d: "M174.16 73.7863H172.285V60.265H174.16V73.7863Z",
  fill: "#3E5C69"
});

var _ref166 = /*#__PURE__*/React.createElement("path", {
  d: "M159.57 73.7863H157.695V60.265H159.57V73.7863Z",
  fill: "#3E5C69"
});

var _ref167 = /*#__PURE__*/React.createElement("path", {
  d: "M159.276 74.4684L157.989 73.1038L171.994 59.9046L173.28 61.2685L159.276 74.4684Z",
  fill: "#3E5C69"
});

var _ref168 = /*#__PURE__*/React.createElement("path", {
  d: "M157.403 74.4684L143.399 61.2685L144.685 59.9046L158.69 73.1038L157.403 74.4684Z",
  fill: "#B0B0B0"
});

var _ref169 = /*#__PURE__*/React.createElement("path", {
  d: "M159.57 73.7863H157.695V60.265H159.57V73.7863Z",
  fill: "#3E5C69"
});

var _ref170 = /*#__PURE__*/React.createElement("path", {
  d: "M144.98 73.7863H143.105V60.265H144.98V73.7863Z",
  fill: "#3E5C69"
});

var _ref171 = /*#__PURE__*/React.createElement("path", {
  d: "M144.686 74.4684L143.399 73.1038L157.404 59.9046L158.69 61.2685L144.686 74.4684Z",
  fill: "#3E5C69"
});

var _ref172 = /*#__PURE__*/React.createElement("path", {
  d: "M142.813 74.4684L128.809 61.2685L130.096 59.9046L144.1 73.1038L142.813 74.4684Z",
  fill: "#B0B0B0"
});

var _ref173 = /*#__PURE__*/React.createElement("path", {
  d: "M144.98 73.7863H143.105V60.265H144.98V73.7863Z",
  fill: "#3E5C69"
});

var _ref174 = /*#__PURE__*/React.createElement("path", {
  d: "M130.39 73.7863H128.515V60.265H130.39V73.7863Z",
  fill: "#3E5C69"
});

var _ref175 = /*#__PURE__*/React.createElement("path", {
  d: "M130.095 74.4684L128.809 73.1038L142.813 59.9046L144.1 61.2685L130.095 74.4684Z",
  fill: "#3E5C69"
});

var _ref176 = /*#__PURE__*/React.createElement("path", {
  d: "M128.223 74.4684L114.219 61.2685L115.506 59.9046L129.51 73.1038L128.223 74.4684Z",
  fill: "#B0B0B0"
});

var _ref177 = /*#__PURE__*/React.createElement("path", {
  d: "M130.39 73.7863H128.515V60.265H130.39V73.7863Z",
  fill: "#3E5C69"
});

var _ref178 = /*#__PURE__*/React.createElement("path", {
  d: "M115.8 73.7863H113.925V60.265H115.8V73.7863Z",
  fill: "#3E5C69"
});

var _ref179 = /*#__PURE__*/React.createElement("path", {
  d: "M115.505 74.4684L114.219 73.1038L128.223 59.9046L129.51 61.2685L115.505 74.4684Z",
  fill: "#3E5C69"
});

var _ref180 = /*#__PURE__*/React.createElement("path", {
  d: "M113.633 74.4684L99.6289 61.2685L100.916 59.9046L114.919 73.1038L113.633 74.4684Z",
  fill: "#B0B0B0"
});

var _ref181 = /*#__PURE__*/React.createElement("path", {
  d: "M115.8 73.7863H113.925V60.265H115.8V73.7863Z",
  fill: "#3E5C69"
});

var _ref182 = /*#__PURE__*/React.createElement("path", {
  d: "M101.21 73.7863H99.3348V60.265H101.21V73.7863Z",
  fill: "#3E5C69"
});

var _ref183 = /*#__PURE__*/React.createElement("path", {
  d: "M100.915 74.4684L99.6288 73.1038L113.633 59.9046L114.919 61.2685L100.915 74.4684Z",
  fill: "#3E5C69"
});

var _ref184 = /*#__PURE__*/React.createElement("path", {
  d: "M99.0431 74.4684L85.0392 61.2685L86.3252 59.9046L100.33 73.1038L99.0431 74.4684Z",
  fill: "#B0B0B0"
});

var _ref185 = /*#__PURE__*/React.createElement("path", {
  d: "M101.21 73.7863H99.3348V60.265H101.21V73.7863Z",
  fill: "#3E5C69"
});

var _ref186 = /*#__PURE__*/React.createElement("path", {
  d: "M86.6194 73.7863H84.7444V60.265H86.6194V73.7863Z",
  fill: "#3E5C69"
});

var _ref187 = /*#__PURE__*/React.createElement("path", {
  d: "M86.3255 74.4684L85.0388 73.1038L99.0433 59.9046L100.329 61.2685L86.3255 74.4684Z",
  fill: "#3E5C69"
});

var _ref188 = /*#__PURE__*/React.createElement("path", {
  d: "M84.1895 76.2299H75.7056V56.7245H84.1895V76.2299Z",
  fill: "#B0B0B0"
});

var _ref189 = /*#__PURE__*/React.createElement("path", {
  d: "M92.6839 76.2299H84.1888V56.7245H92.6839V76.2299Z",
  fill: "#3E5C69"
});

var _ref190 = /*#__PURE__*/React.createElement("path", {
  d: "M103.905 85.9578H87.6157V76.2298H103.905V85.9578Z",
  fill: "#3E5C69"
});

var _ref191 = /*#__PURE__*/React.createElement("path", {
  d: "M261.906 76.2299H84.1895V71.3415H261.906V76.2299Z",
  fill: "#3E5C69"
});

var _ref192 = /*#__PURE__*/React.createElement("path", {
  d: "M251.769 61.6132H84.1895V56.7248H246.993L251.769 61.6132Z",
  fill: "#3E5C69"
});

var _ref193 = /*#__PURE__*/React.createElement("path", {
  d: "M250.305 73.7863H248.43V60.265H250.305V73.7863Z",
  fill: "#3E5C69"
});

var _ref194 = /*#__PURE__*/React.createElement("path", {
  d: "M181.856 129.388L193.594 127.509L205.34 125.69L228.848 122.152L228.908 122.143L228.969 122.158L268.093 132.305L287.642 137.431L307.174 142.622L287.566 137.729L267.973 132.772L228.816 122.752L228.937 122.758L205.408 126.153L193.637 127.801L181.856 129.388Z",
  fill: "#B0B0B0"
});

var _ref195 = /*#__PURE__*/React.createElement("path", {
  d: "M221.712 105.909H219.837V78.2229H221.712V105.909Z",
  fill: "#B0B0B0"
});

var _ref196 = /*#__PURE__*/React.createElement("path", {
  d: "M237.576 106.527H235.701V78.8408H237.576V106.527Z",
  fill: "#B0B0B0"
});

var _ref197 = /*#__PURE__*/React.createElement("path", {
  d: "M241.2 80.2153H216.473V76.2298H241.2V80.2153Z",
  fill: "#3E5C69"
});

var _ref198 = /*#__PURE__*/React.createElement("path", {
  d: "M229.774 110.566L229.566 114.725L228.966 114.007C229.68 114.191 230.264 114.455 230.855 114.821C231.432 115.182 231.969 115.665 232.339 116.281C233.107 117.521 232.995 119.116 232.241 120.235C231.506 121.377 230.174 122.013 228.894 121.968C227.583 121.928 226.477 121.104 225.789 120.117C226.578 121.038 227.721 121.69 228.892 121.603C230.041 121.528 231.122 120.842 231.615 119.86C232.13 118.906 232.051 117.683 231.429 116.888C230.832 116.084 229.706 115.61 228.706 115.444L228.138 115.35L228.106 114.725L227.899 110.566H229.774Z",
  fill: "#B0B0B0"
});

var _ref199 = /*#__PURE__*/React.createElement("path", {
  d: "M241.2 102.035V108.823L228.834 111.757L216.478 108.823V102.035H241.2Z",
  fill: "#3E5C69"
});

var _ref200 = /*#__PURE__*/React.createElement("path", {
  d: "M222.147 106.017C222.147 106.809 221.504 107.452 220.711 107.452C219.918 107.452 219.275 106.809 219.275 106.017C219.275 105.224 219.918 104.581 220.711 104.581C221.504 104.581 222.147 105.224 222.147 106.017Z",
  fill: "#B0B0B0"
});

var _ref201 = /*#__PURE__*/React.createElement("path", {
  d: "M238.397 106.017C238.397 106.809 237.754 107.452 236.961 107.452C236.168 107.452 235.526 106.809 235.526 106.017C235.526 105.224 236.168 104.581 236.961 104.581C237.754 104.581 238.397 105.224 238.397 106.017Z",
  fill: "#B0B0B0"
});

var _ref202 = /*#__PURE__*/React.createElement("path", {
  d: "M178 157.667L304.099 171.225L307.174 142.621L181.076 129.063L178 157.667Z",
  fill: "#F6851F"
});

var _ref203 = /*#__PURE__*/React.createElement("path", {
  d: "M246.939 158.845L304.762 165.062L277.523 146.404L246.939 158.845Z",
  fill: "#F6851F"
});

var _ref204 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.199997
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.199997
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.199997,
  d: "M246.939 158.845L304.762 165.062L277.523 146.404L246.939 158.845Z",
  fill: "black"
})));

var _ref205 = /*#__PURE__*/React.createElement("path", {
  d: "M218.47 155.798L269.748 161.311L245.198 148.429L218.47 155.798Z",
  fill: "#F6851F"
});

var _ref206 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.100006,
  d: "M218.47 155.798L269.748 161.311L245.198 148.429L218.47 155.798Z",
  fill: "black"
})));

var _ref207 = /*#__PURE__*/React.createElement("path", {
  d: "M304.099 171.225L178 157.667L178.663 151.504L304.761 165.062L304.099 171.225Z",
  fill: "#F6851F"
});

var _ref208 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.100006,
  d: "M304.099 171.225L178 157.667L178.663 151.504L304.761 165.062L304.099 171.225Z",
  fill: "black"
})));

var _ref209 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.600006
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.600006
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.600006,
  d: "M196.625 140.214C196.394 142.361 194.466 143.915 192.319 143.684C190.171 143.453 188.617 141.525 188.849 139.377C189.079 137.23 191.007 135.676 193.155 135.907C195.302 136.138 196.856 138.066 196.625 140.214Z",
  fill: "white"
})));

var _ref210 = /*#__PURE__*/React.createElement("path", {
  d: "M125.651 34.2772C125.651 36.025 124.234 37.4414 122.487 37.4414C120.739 37.4414 119.323 36.025 119.323 34.2772C119.323 32.5295 120.739 31.1131 122.487 31.1131C124.234 31.1131 125.651 32.5295 125.651 34.2772Z",
  fill: "#A8A8A8"
});

var _ref211 = /*#__PURE__*/React.createElement("path", {
  d: "M123.964 34.2772C123.964 35.0936 123.303 35.7549 122.486 35.7549C121.671 35.7549 121.009 35.0936 121.009 34.2772C121.009 33.4615 121.671 32.7996 122.486 32.7996C123.303 32.7996 123.964 33.4615 123.964 34.2772Z",
  fill: "#3E5C69"
});

var _ref212 = /*#__PURE__*/React.createElement("path", {
  d: "M136.017 248.265H108.712V241.812H136.017V248.265Z",
  fill: "#B0B0B0"
});

var _ref213 = /*#__PURE__*/React.createElement("path", {
  d: "M141.936 260.922H102.795V248.266H141.936V260.922Z",
  fill: "#3E5C69"
});

var _ref214 = /*#__PURE__*/React.createElement("path", {
  d: "M138.242 87.514H109.022V55.1698H128.105C131.447 55.1698 134.273 57.6455 134.714 60.9592L138.242 87.514Z",
  fill: "#F6851F"
});

var _ref215 = /*#__PURE__*/React.createElement("path", {
  d: "M130.292 77.6858H116.594C116.435 77.6858 116.294 77.6673 116.154 77.6203C115.516 77.4324 115.057 76.833 115.057 76.1389V58.8609H124.798C125.126 58.8609 125.454 58.8887 125.773 58.9542C126.522 59.0852 127.216 59.3664 127.816 59.77C128.248 60.0604 128.632 60.4077 128.951 60.8014C129.598 61.5696 130.038 62.517 130.179 63.5762L131.82 75.9325C131.942 76.8608 131.219 77.6858 130.292 77.6858Z",
  fill: "#E4EBF3"
});

var _ref216 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.399994,
  d: "M128.82 68.6667C128.82 69.0604 128.669 69.454 128.37 69.7544L120.438 77.6858H116.594C116.435 77.6858 116.294 77.6666 116.154 77.6203L126.194 67.579C126.794 66.9796 127.77 66.9796 128.37 67.579C128.669 67.8794 128.82 68.273 128.82 68.6667Z",
  fill: "white"
});

var _ref217 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.399994,
  d: "M128.951 60.8011L115.057 74.6949V72.5295L127.817 59.7702C128.248 60.0601 128.632 60.4074 128.951 60.8011Z",
  fill: "white"
});

var _ref218 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.399994,
  d: "M125.772 58.9544L117.879 66.8481C117.429 67.298 116.698 67.298 116.247 66.8481C116.022 66.6232 115.91 66.3321 115.91 66.0324C115.91 65.7419 116.022 65.4514 116.247 65.2259L122.613 58.8605H124.797C125.126 58.8605 125.454 58.8889 125.772 58.9544Z",
  fill: "white"
});

var _ref219 = /*#__PURE__*/React.createElement("path", {
  d: "M77.86 225.68L77.2692 229.881L76.6333 234.396L70.8284 275.565H61.3359L67.1408 234.396L67.7767 229.881L68.3675 225.68H77.86Z",
  fill: "#F6851F"
});

var _ref220 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.100006,
  d: "M105.584 222.214C105.085 226.384 104.547 230.547 104.003 234.71L102.329 247.188L100.576 259.653L99.6702 265.879L98.7278 272.1L99.4997 265.848L100.309 259.603L101.983 247.125L103.737 234.661C104.337 230.509 104.942 226.358 105.584 222.214Z",
  fill: "black"
})));

var _ref221 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.100006,
  d: "M106.369 226.415L105.733 230.929H96.2406L96.8765 226.415H106.369Z",
  fill: "black"
})));

var _ref222 = /*#__PURE__*/React.createElement("path", {
  d: "M124.72 225.68L125.311 229.881L125.947 234.396L131.751 275.565H141.244L135.44 234.396L134.803 229.881L134.212 225.68H124.72Z",
  fill: "#F6851F"
});

var _ref223 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.100006,
  d: "M155.225 222.214C155.725 226.384 156.263 230.547 156.806 234.71L158.48 247.188L160.234 259.653L161.139 265.879L162.082 272.1L161.31 265.848L160.501 259.603L158.827 247.125L157.072 234.661C156.473 230.509 155.868 226.358 155.225 222.214Z",
  fill: "black"
})));

var _ref224 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.100006,
  d: "M154.41 226.415H163.903L164.539 230.929H155.047L154.41 226.415Z",
  fill: "black"
})));

var _ref225 = /*#__PURE__*/React.createElement("path", {
  d: "M106.614 213.578H99.0873L100.023 206.561H105.678L106.614 213.578Z",
  fill: "#F6851F"
});

var _ref226 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.100006,
  d: "M77.514 217.044H69.9874L70.9231 210.027H76.5784L77.514 217.044Z",
  fill: "black"
})));

var _ref227 = /*#__PURE__*/React.createElement("path", {
  d: "M80.7648 205.014C80.7648 208.888 77.6241 212.029 73.7505 212.029C69.8769 212.029 66.7368 208.888 66.7368 205.014C66.7368 201.14 69.8769 198 73.7505 198C77.6241 198 80.7648 201.14 80.7648 205.014Z",
  fill: "#F6851F"
});

var _ref228 = /*#__PURE__*/React.createElement("path", {
  d: "M79.0828 205.014C79.0828 207.959 76.6955 210.346 73.7507 210.346C70.8059 210.346 68.4186 207.959 68.4186 205.014C68.4186 202.069 70.8059 199.682 73.7507 199.682C76.6955 199.682 79.0828 202.069 79.0828 205.014Z",
  fill: "white"
});

var _ref229 = /*#__PURE__*/React.createElement("path", {
  d: "M78.2076 204.705C78.1137 203.403 77.4512 202.204 76.4667 201.433C75.4791 200.659 74.1733 200.301 72.8804 200.494C71.6315 200.68 70.4962 201.422 69.7985 202.498C69.0915 203.575 68.8523 204.986 69.2361 206.344C69.5445 207.458 70.3219 208.423 71.3181 208.98C72.3125 209.546 73.5028 209.72 74.5818 209.482C75.6682 209.253 76.6472 208.645 77.3202 207.806C77.9981 206.971 78.4035 205.918 78.4468 204.834C78.4499 204.784 78.4313 204.741 78.4047 204.739C78.3794 204.739 78.3565 204.778 78.3535 204.831C78.3355 205.271 78.2391 205.703 78.1044 206.116C77.9592 206.528 77.7571 206.915 77.5148 207.274C77.2645 207.628 76.9704 207.947 76.641 208.233C76.306 208.512 75.9352 208.751 75.5341 208.948C74.4032 209.491 73.0553 209.53 71.8947 209.036C70.736 208.551 69.8016 207.546 69.4264 206.328C69.0229 205.038 69.2219 203.659 69.893 202.595C70.5592 201.533 71.6735 200.798 72.8934 200.621C74.5781 200.379 76.2788 200.997 77.3103 202.379C77.5593 202.72 77.7546 203.095 77.906 203.488C78.0506 203.885 78.1384 204.3 78.186 204.726C78.1884 204.739 78.1959 204.743 78.202 204.739C78.2076 204.734 78.2101 204.719 78.2076 204.705Z",
  fill: "#F6851F"
});

var _ref230 = /*#__PURE__*/React.createElement("path", {
  d: "M77.5835 204.71C77.4895 203.59 76.9154 202.575 76.0731 201.917C75.227 201.26 74.1202 200.952 73.0096 201.105C71.9399 201.253 70.9542 201.88 70.3423 202.805C69.7225 203.726 69.5025 204.952 69.8251 206.136C70.0828 207.109 70.7614 207.956 71.6321 208.44C72.4998 208.933 73.5393 209.081 74.4786 208.866C75.4223 208.662 76.2683 208.128 76.8487 207.396C77.4327 206.669 77.7812 205.761 77.8232 204.822C77.8251 204.777 77.8072 204.74 77.7806 204.738C77.7553 204.738 77.7324 204.773 77.7293 204.818C77.6502 206.355 76.6731 207.704 75.2944 208.373C74.3241 208.848 73.1512 208.891 72.1463 208.464C71.1408 208.047 70.3294 207.17 70.013 206.114C69.6718 204.996 69.8547 203.803 70.4394 202.897C71.0209 201.989 71.985 201.37 73.0251 201.231C74.4632 201.044 75.8969 201.553 76.7924 202.726C77.0062 203.016 77.175 203.334 77.3091 203.669C77.4351 204.007 77.5149 204.361 77.5618 204.728C77.5649 204.738 77.5717 204.743 77.5779 204.738C77.5841 204.734 77.5859 204.722 77.5835 204.71Z",
  fill: "#F6851F"
});

var _ref231 = /*#__PURE__*/React.createElement("path", {
  d: "M76.9593 204.715C76.8647 203.777 76.3796 202.946 75.6788 202.402C74.9749 201.861 74.0677 201.603 73.1382 201.715C72.2483 201.826 71.4127 202.339 70.8862 203.111C70.3529 203.878 70.152 204.916 70.4134 205.928C70.6217 206.759 71.2008 207.489 71.9455 207.901C72.6871 208.319 73.5751 208.441 74.3748 208.251C75.1757 208.07 75.8895 207.612 76.3765 206.988C76.8672 206.367 77.1595 205.605 77.1991 204.809C77.2009 204.772 77.1824 204.74 77.1558 204.738C77.1311 204.738 77.1076 204.768 77.1051 204.806C77.0291 206.101 76.2053 207.221 75.054 207.796C74.2438 208.206 73.2463 208.251 72.3972 207.893C71.5456 207.543 70.8565 206.794 70.5988 205.9C70.3207 204.954 70.487 203.949 70.9857 203.199C71.4832 202.445 72.2959 201.942 73.1555 201.842C73.7574 201.778 74.339 201.844 74.8748 202.047C75.4093 202.251 75.8988 202.596 76.2733 203.074C76.4531 203.312 76.5953 203.574 76.7115 203.85C76.8196 204.129 76.8901 204.423 76.937 204.73C76.9408 204.738 76.9475 204.743 76.9537 204.738C76.9593 204.735 76.9618 204.725 76.9593 204.715Z",
  fill: "#F6851F"
});

var _ref232 = /*#__PURE__*/React.createElement("path", {
  d: "M76.3352 204.719C76.2407 203.964 75.8433 203.316 75.2846 202.886C74.7229 202.463 74.0146 202.253 73.2675 202.326C72.5568 202.399 71.8708 202.798 71.4302 203.418C70.984 204.029 70.8017 204.882 71.0019 205.72C71.1601 206.409 71.6397 207.022 72.2589 207.36C72.8744 207.705 73.6117 207.801 74.2711 207.635C74.9293 207.478 75.5108 207.095 75.9051 206.579C76.3019 206.065 76.5373 205.449 76.575 204.796C76.5769 204.765 76.5583 204.74 76.5318 204.738C76.5064 204.738 76.4836 204.762 76.4811 204.793C76.4082 205.846 75.7382 206.737 74.8137 207.221C74.1642 207.564 73.3416 207.612 72.6476 207.321C71.9499 207.039 71.3832 206.417 71.1854 205.686C70.9704 204.912 71.1199 204.094 71.5321 203.5C71.945 202.901 72.6068 202.513 73.286 202.452C73.7637 202.415 74.2198 202.469 74.6394 202.625C75.0591 202.782 75.4496 203.047 75.7549 203.421C75.9002 203.608 76.0157 203.813 76.114 204.031C76.2048 204.251 76.266 204.484 76.313 204.732C76.3161 204.738 76.3229 204.743 76.3297 204.738C76.3352 204.736 76.3377 204.728 76.3352 204.719Z",
  fill: "#F6851F"
});

var _ref233 = /*#__PURE__*/React.createElement("path", {
  d: "M132.43 217.044H124.903L125.839 210.027H131.494L132.43 217.044Z",
  fill: "#F6851F"
});

var _ref234 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.100006,
  d: "M132.43 217.044H124.903L125.839 210.027H131.494L132.43 217.044Z",
  fill: "black"
})));

var _ref235 = /*#__PURE__*/React.createElement("path", {
  d: "M135.68 205.014C135.68 208.888 132.54 212.029 128.666 212.029C124.793 212.029 121.652 208.888 121.652 205.014C121.652 201.14 124.793 198 128.666 198C132.54 198 135.68 201.14 135.68 205.014Z",
  fill: "#F6851F"
});

var _ref236 = /*#__PURE__*/React.createElement("path", {
  d: "M133.998 205.014C133.998 207.959 131.611 210.346 128.666 210.346C125.722 210.346 123.334 207.959 123.334 205.014C123.334 202.069 125.722 199.682 128.666 199.682C131.611 199.682 133.998 202.069 133.998 205.014Z",
  fill: "white"
});

var _ref237 = /*#__PURE__*/React.createElement("path", {
  d: "M133.123 204.705C133.029 203.403 132.367 202.204 131.382 201.433C130.395 200.659 129.089 200.301 127.796 200.494C126.547 200.68 125.411 201.422 124.714 202.498C124.007 203.575 123.768 204.986 124.152 206.344C124.46 207.458 125.237 208.423 126.234 208.98C127.228 209.546 128.419 209.72 129.498 209.482C130.584 209.253 131.563 208.645 132.236 207.806C132.914 206.971 133.319 205.918 133.363 204.834C133.365 204.784 133.347 204.741 133.32 204.739C133.295 204.739 133.272 204.778 133.269 204.831C133.251 205.271 133.155 205.703 133.02 206.116C132.874 206.528 132.673 206.915 132.431 207.274C132.18 207.628 131.886 207.947 131.557 208.233C131.222 208.512 130.85 208.751 130.45 208.948C129.319 209.491 127.971 209.53 126.811 209.036C125.652 208.551 124.717 207.546 124.342 206.328C123.938 205.038 124.138 203.659 124.808 202.595C125.475 201.533 126.589 200.798 127.809 200.621C129.494 200.379 131.195 200.997 132.226 202.379C132.475 202.72 132.67 203.095 132.822 203.488C132.966 203.885 133.054 204.3 133.101 204.726C133.104 204.739 133.112 204.743 133.118 204.739C133.123 204.734 133.126 204.719 133.123 204.705Z",
  fill: "#F6851F"
});

var _ref238 = /*#__PURE__*/React.createElement("path", {
  d: "M132.499 204.71C132.405 203.59 131.831 202.575 130.988 201.917C130.143 201.26 129.036 200.952 127.925 201.105C126.855 201.253 125.87 201.88 125.258 202.805C124.638 203.726 124.418 204.952 124.74 206.136C124.999 207.109 125.676 207.956 126.548 208.44C127.415 208.933 128.455 209.081 129.394 208.866C130.338 208.662 131.184 208.128 131.764 207.396C132.348 206.669 132.697 205.761 132.739 204.822C132.741 204.777 132.723 204.74 132.696 204.738C132.671 204.738 132.647 204.773 132.645 204.818C132.566 206.355 131.589 207.704 130.209 208.373C129.239 208.848 128.067 208.891 127.062 208.464C126.056 208.047 125.245 207.17 124.928 206.114C124.587 204.996 124.77 203.803 125.355 202.897C125.936 201.989 126.9 201.37 127.94 201.231C129.379 201.044 130.812 201.553 131.707 202.726C131.922 203.016 132.09 203.334 132.225 203.669C132.351 204.007 132.43 204.361 132.477 204.728C132.48 204.738 132.487 204.743 132.493 204.738C132.499 204.734 132.501 204.722 132.499 204.71Z",
  fill: "#F6851F"
});

var _ref239 = /*#__PURE__*/React.createElement("path", {
  d: "M131.875 204.715C131.781 203.777 131.295 202.946 130.595 202.402C129.891 201.861 128.983 201.603 128.054 201.715C127.164 201.826 126.329 202.339 125.801 203.111C125.269 203.878 125.068 204.916 125.329 205.928C125.537 206.759 126.117 207.489 126.861 207.901C127.603 208.319 128.491 208.441 129.29 208.251C130.092 208.07 130.805 207.612 131.292 206.988C131.783 206.367 132.075 205.605 132.115 204.809C132.117 204.772 132.098 204.74 132.072 204.738C132.046 204.738 132.023 204.768 132.021 204.806C131.945 206.101 131.121 207.221 129.97 207.796C129.16 208.206 128.162 208.251 127.312 207.893C126.461 207.543 125.772 206.794 125.515 205.9C125.237 204.954 125.403 203.949 125.901 203.199C126.398 202.445 127.212 201.942 128.071 201.842C128.673 201.778 129.255 201.844 129.791 202.047C130.325 202.251 130.815 202.596 131.189 203.074C131.369 203.312 131.511 203.574 131.627 203.85C131.735 204.129 131.806 204.423 131.853 204.73C131.856 204.738 131.863 204.743 131.87 204.738C131.875 204.735 131.878 204.725 131.875 204.715Z",
  fill: "#F6851F"
});

var _ref240 = /*#__PURE__*/React.createElement("path", {
  d: "M131.251 204.719C131.156 203.964 130.759 203.316 130.201 202.886C129.638 202.463 128.93 202.253 128.183 202.326C127.472 202.399 126.787 202.798 126.346 203.418C125.899 204.029 125.718 204.882 125.918 205.72C126.075 206.409 126.556 207.022 127.175 207.36C127.79 207.705 128.527 207.801 129.187 207.635C129.845 207.478 130.426 207.095 130.82 206.579C131.217 206.065 131.453 205.449 131.49 204.796C131.492 204.765 131.474 204.74 131.448 204.738C131.422 204.738 131.4 204.762 131.396 204.793C131.324 205.846 130.654 206.737 129.729 207.221C129.08 207.564 128.258 207.612 127.564 207.321C126.866 207.039 126.299 206.417 126.101 205.686C125.886 204.912 126.035 204.094 126.448 203.5C126.86 202.901 127.523 202.513 128.202 202.452C128.679 202.415 129.136 202.469 129.555 202.625C129.975 202.782 130.365 203.047 130.67 203.421C130.816 203.608 130.931 203.813 131.029 204.031C131.12 204.251 131.182 204.484 131.228 204.732C131.231 204.738 131.239 204.743 131.245 204.738C131.251 204.736 131.253 204.728 131.251 204.719Z",
  fill: "#F6851F"
});

var _ref241 = /*#__PURE__*/React.createElement("path", {
  d: "M148.58 231.558H54V213.468H148.58V231.558Z",
  fill: "white",
  stroke: "#B0B0B0",
  strokeWidth: 0.309,
  strokeMiterlimit: 10
});

var _ref242 = /*#__PURE__*/React.createElement("path", {
  d: "M73.4388 213.468L66.5746 231.558H54.3605L61.2246 213.468H73.4388Z",
  fill: "#F6851F"
});

var _ref243 = /*#__PURE__*/React.createElement("path", {
  d: "M98.4771 213.468L91.613 231.558H79.3945L86.2587 213.468H98.4771Z",
  fill: "#F6851F"
});

var _ref244 = /*#__PURE__*/React.createElement("path", {
  d: "M123.511 213.468L116.647 231.558H104.432L111.296 213.468H123.511Z",
  fill: "#F6851F"
});

var _ref245 = /*#__PURE__*/React.createElement("path", {
  d: "M148.549 213.468L141.685 231.558H129.466L136.33 213.468H148.549Z",
  fill: "#F6851F"
});

var _ref246 = /*#__PURE__*/React.createElement("path", {
  d: "M146.665 265.118H55.9146V253.669H146.665V265.118Z",
  fill: "white",
  stroke: "#B0B0B0",
  strokeWidth: 0.309,
  strokeMiterlimit: 10
});

var _ref247 = /*#__PURE__*/React.createElement("path", {
  d: "M74.5664 253.669L67.9798 265.118H56.2606L62.8473 253.669H74.5664Z",
  fill: "#F6851F"
});

var _ref248 = /*#__PURE__*/React.createElement("path", {
  d: "M98.5909 253.669L92.0042 265.118H80.2808L86.8668 253.669H98.5909Z",
  fill: "#F6851F"
});

var _ref249 = /*#__PURE__*/React.createElement("path", {
  d: "M122.611 253.669L116.024 265.118H104.305L110.892 253.669H122.611Z",
  fill: "#F6851F"
});

var _ref250 = /*#__PURE__*/React.createElement("path", {
  d: "M146.636 253.669L140.049 265.118H128.325L134.911 253.669H146.636Z",
  fill: "#F6851F"
});

var _ref251 = /*#__PURE__*/React.createElement("path", {
  d: "M116.008 222.513C116.008 230.641 109.418 237.23 101.29 237.23C93.1615 237.23 86.5724 230.641 86.5724 222.513C86.5724 214.385 93.1615 207.796 101.29 207.796C109.418 207.796 116.008 214.385 116.008 222.513Z",
  fill: "white"
});

var _ref252 = /*#__PURE__*/React.createElement("path", {
  d: "M116.008 222.513C116.008 230.641 109.418 237.23 101.29 237.23C93.1615 237.23 86.5724 230.641 86.5724 222.513C86.5724 214.385 93.1615 207.796 101.29 207.796C109.418 207.796 116.008 214.385 116.008 222.513Z",
  stroke: "#B0B0B0",
  strokeWidth: 0.309,
  strokeMiterlimit: 10
});

var _ref253 = /*#__PURE__*/React.createElement("path", {
  d: "M113.769 222.513C113.769 229.405 108.182 234.992 101.29 234.992C94.3976 234.992 88.8103 229.405 88.8103 222.513C88.8103 215.621 94.3976 210.033 101.29 210.033C108.182 210.033 113.769 215.621 113.769 222.513Z",
  fill: "#F6851F"
});

var _ref254 = /*#__PURE__*/React.createElement("path", {
  d: "M109.114 223.962H93.4648V221.063H109.114V223.962Z",
  fill: "white"
});

var _ref255 = /*#__PURE__*/React.createElement("path", {
  d: "M336.327 273.613L339.456 252.09L340.364 252.499L341.813 253.157L348.091 255.991L353.721 258.536L357.425 260.208L363.05 262.751L366.138 264.146C368.567 265.462 368.039 269.09 365.336 269.66L364.033 269.839L364.029 269.839L361.979 270.118L355.863 270.949L351.835 271.498L345.715 272.333L343.157 272.681L336.327 273.613Z",
  fill: "#F6851F"
});

var _ref256 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.100006,
  d: "M340.519 252.692C340.519 252.692 340.064 253.937 339.372 255.016C337.461 257.991 336.08 264.089 337.121 271.116C337.209 271.709 337.308 272.762 337.584 273.333L338.892 273.247C338.892 273.247 344.992 259.858 364.939 263.583L363.053 262.731L357.427 260.193L353.722 258.519L348.094 255.975L340.519 252.692Z",
  fill: "black"
})));

var _ref257 = /*#__PURE__*/React.createElement("path", {
  d: "M355.863 270.95L357.425 260.208L363.05 262.751L361.979 270.118L355.863 270.95Z",
  fill: "#ECECEC"
});

var _ref258 = /*#__PURE__*/React.createElement("path", {
  d: "M345.715 272.333L348.091 255.992L353.721 258.535L351.835 271.498L345.715 272.333Z",
  fill: "#ECECEC"
});

var _ref259 = /*#__PURE__*/React.createElement("path", {
  d: "M281.424 273.078H260.475L260.738 272.155L261.165 270.683L262.997 264.306L264.641 258.588L265.722 254.825L267.366 249.11L268.268 245.975C269.185 243.476 272.717 243.476 273.635 245.975L273.987 247.191V247.195L274.537 249.11L276.177 254.825L277.258 258.588L278.903 264.306L279.589 266.697L281.424 273.078Z",
  fill: "#F6851F"
});

var _ref260 = /*#__PURE__*/React.createElement("path", {
  d: "M282.174 278.515H254.64L259.03 267.64H286.565L282.174 278.515Z",
  fill: "#F6851F"
});

var _ref261 = /*#__PURE__*/React.createElement("path", {
  d: "M276.177 254.825H265.722L267.366 249.11H274.537L276.177 254.825Z",
  fill: "#ECECEC"
});

var _ref262 = /*#__PURE__*/React.createElement("path", {
  d: "M278.903 264.306H262.997L264.641 258.588H277.258L278.903 264.306Z",
  fill: "#ECECEC"
});

var _ref263 = /*#__PURE__*/React.createElement("path", {
  d: "M260.182 271.619C261.881 272.413 263.679 272.903 265.492 273.235C267.308 273.556 269.15 273.685 270.991 273.654C271.909 273.593 272.832 273.588 273.745 273.444C274.203 273.384 274.665 273.354 275.118 273.272C275.572 273.183 276.027 273.101 276.483 273.022C276.711 272.978 276.941 272.946 277.167 272.895L277.841 272.726L279.196 272.399C280.095 272.156 280.977 271.857 281.889 271.619C281.044 272.021 280.191 272.422 279.317 272.772L277.98 273.23L277.308 273.454C277.082 273.521 276.851 273.569 276.622 273.629C276.164 273.743 275.704 273.855 275.243 273.96C274.781 274.063 274.309 274.114 273.842 274.193C272.907 274.362 271.956 274.376 271.01 274.451C269.111 274.468 267.205 274.298 265.362 273.842C263.528 273.387 261.723 272.705 260.182 271.619Z",
  fill: "black",
  fillOpacity: 0.38
});

var _ref264 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.100006,
  d: "M260.901 271.981C260.901 271.981 262.15 272.242 263.276 272.753C266.376 274.161 272.379 274.633 278.933 272.667C279.487 272.501 280.476 272.261 280.983 271.917L280.719 270.683C280.719 270.683 267.112 266.724 267.898 247.195L267.347 249.11L265.707 254.825L264.625 258.588L262.981 264.306L260.901 271.981Z",
  fill: "black"
})));

var _ref265 = /*#__PURE__*/React.createElement("path", {
  d: "M330.629 273.572L334.742 245.285L345.258 251.418L341.145 279.707L330.629 273.572Z",
  fill: "#F6851F"
});

var _ref266 = /*#__PURE__*/React.createElement("path", {
  d: "M341.107 263.127C340.518 268.353 338.625 272.431 336.878 272.234C335.132 272.038 334.193 267.641 334.781 262.415C335.37 257.188 337.263 253.11 339.009 253.307C340.756 253.503 341.695 257.9 341.107 263.127Z",
  fill: "black",
  fillOpacity: 0.38
});

function SvgPageConstruction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 546,
    height: 474,
    viewBox: "0 0 546 474",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177, _ref178, _ref179, _ref180, _ref181, _ref182, _ref183, _ref184, _ref185, _ref186, _ref187, _ref188, _ref189, _ref190, _ref191, _ref192, _ref193, _ref194, _ref195, _ref196, _ref197, _ref198, _ref199, _ref200, _ref201, _ref202, _ref203, _ref204, _ref205, _ref206, _ref207, _ref208, _ref209, _ref210, _ref211, _ref212, _ref213, _ref214, _ref215, _ref216, _ref217, _ref218, _ref219, _ref220, _ref221, _ref222, _ref223, _ref224, _ref225, _ref226, _ref227, _ref228, _ref229, _ref230, _ref231, _ref232, _ref233, _ref234, _ref235, _ref236, _ref237, _ref238, _ref239, _ref240, _ref241, _ref242, _ref243, _ref244, _ref245, _ref246, _ref247, _ref248, _ref249, _ref250, _ref251, _ref252, _ref253, _ref254, _ref255, _ref256, _ref257, _ref258, _ref259, _ref260, _ref261, _ref262, _ref263, _ref264, _ref265, _ref266);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageConstruction);
export default __webpack_public_path__ + "static/media/page-construction.736f9992.svg";
export { ForwardRef as ReactComponent };